import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { getAppointmentOrders, getReportById, reviewReport, updateReportContent, generateReportContent, getChecksByVisitId, getVisitById, getPatientById, getConversationMessagesByVisitId, getPendingChecksByVisitId, reviewPendingCheck, createReport, createPendingCheck, deletePendingCheck } from '../api/reportApi';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../utils/auth';
import { buildReportPatientInfo } from '../utils/reportPatientInfo';


/* 
// 添加Markdown样式CSS（保留以便后续可能使用）
const markdownStyles = `
  .markdown-content {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    line-height: 1.6;
    color: #333;
    text-align: left;
  }
  
  .markdown-content h1 {
    color: #2c3e50;
    font-size: 1.8em;
    margin-top: 1.5em;
    margin-bottom: 0.8em;
    padding-bottom: 0.3em;
    border-bottom: 1px solid #eaecef;
    text-align: left;
    font-weight: 700;
  }
  
  .markdown-content h2 {
    color: #3498db;
    font-size: 1.5em;
    margin-top: 1.2em;
    margin-bottom: 0.6em;
    text-align: left;
    font-weight: 600;
  }
  
  .markdown-content h3 {
    color: #2980b9;
    font-size: 1.3em;
    margin-top: 1em;
    margin-bottom: 0.5em;
    text-align: left;
  }
  
  .markdown-content p {
    margin-top: 0.5em;
    margin-bottom: 1em;
    text-align: left;
  }
  
  .markdown-content ul, .markdown-content ol {
    margin-top: 0.5em;
    margin-bottom: 1em;
    padding-left: 2em;
    text-align: left;
  }
  
  .markdown-content li {
    margin-bottom: 0.3em;
    text-align: left;
  }
  
  .markdown-content img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 1.5em 0;
    border-radius: 4px;
  }
  
  .markdown-content blockquote {
    margin: 1em 0;
    padding: 0.5em 1em;
    border-left: 4px solid #3498db;
    background-color: #f8f9fa;
    color: #666;
  }
  
  .markdown-content code {
    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
    background-color: #f6f8fa;
    padding: 0.2em 0.4em;
    border-radius: 3px;
    font-size: 0.9em;
  }
  
  .markdown-content pre {
    background-color: #f6f8fa;
    padding: 1em;
    overflow-x: auto;
    border-radius: 4px;
    margin: 1em 0;
  }
  
  .markdown-content pre code {
    background-color: transparent;
    padding: 0;
    font-size: 0.9em;
    color: #333;
  }
  
  .markdown-content table {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;
    overflow-x: auto;
    display: block;
  }
  
  .markdown-content table th {
    background-color: #f8f9fa;
    border: 1px solid #dfe2e5;
    padding: 0.5em 1em;
    font-weight: 600;
  }
  
  .markdown-content table td {
    border: 1px solid #dfe2e5;
    padding: 0.5em 1em;
  }
  
  .markdown-content hr {
    height: 0.2em;
    padding: 0;
    margin: 1.5em 0;
    background-color: #e1e4e8;
    border: 0;
  }
  
  .markdown-content a {
    color: #0366d6;
    text-decoration: none;
  }
  
  .markdown-content a:hover {
    text-decoration: underline;
  }
  
  // 检查项列表样式
  .checks-container {
    margin-bottom: 20px;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    padding: 15px;
  }
  
  .checks-list-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }
  
  .checks-list-table th {
    background-color: #f0f7fb;
    padding: 10px;
    text-align: left;
    font-weight: bold;
    color: #2c3e50;
    border-bottom: 2px solid #ddd;
  }
  
  .checks-list-table td {
    padding: 12px 10px;
    border-bottom: 1px solid #eee;
    vertical-align: middle;
  }
  
  .check-row:hover {
    background-color: #f8f9fa;
  }
  
  .check-type {
    font-weight: bold;
    color: #2c3e50;
  }
  
  .check-date {
    color: #7f8c8d;
    font-size: 13px;
    white-space: nowrap;
  }
  
  .check-toggle-btn {
    background-color: #f0f7fb;
    border: 1px solid #d6eaf8;
    color: #3498db;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .check-toggle-btn:hover {
    background-color: #d6eaf8;
  }
  
  .check-details {
    display: none;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin-top: 10px;
  }
  
  .check-metadata {
    margin-bottom: 15px;
  }
  
  .check-metadata table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .check-metadata th {
    text-align: left;
    padding: 8px;
    background-color: #eef7fa;
    border: 1px solid #dde6e9;
    width: 30%;
    font-weight: 600;
  }
  
  .check-metadata td {
    padding: 8px;
    border: 1px solid #dde6e9;
  }
`;
*/



const ReportReview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isZh = i18n.language.startsWith('zh');
  const { currentUser } = useAuth();

  const [report, setReport] = useState(null);
  const [visit, setVisit] = useState(null);
  const [reportContent, setReportContent] = useState('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [viewMode, setViewMode] = useState('preview'); // 默认为预览模式
  const [checks, setChecks] = useState([]);
  const [checksLoading, setChecksLoading] = useState(true);
  const [checksError, setChecksError] = useState('');
  const [checksReady, setChecksReady] = useState(false); // 检查项是否已准备好

  // 待检查项目相关状态
  const [pendingChecks, setPendingChecks] = useState([]);
  const [pendingChecksLoading, setPendingChecksLoading] = useState(false);
  const [pendingChecksError, setPendingChecksError] = useState('');
  const [appointmentOrders, setAppointmentOrders] = useState([]);
  const [appointmentDrafts, setAppointmentDrafts] = useState([{ check_type: '', description: '' }]);
  
  // 审核待检查项目相关状态
  const [reviewingPendingCheck, setReviewingPendingCheck] = useState(null);
  const [reviewSubmitting, setReviewSubmitting] = useState(false);
  
  // 创建待检查项目相关状态
  const [showCreatePendingCheck, setShowCreatePendingCheck] = useState(false);
  const [createPendingCheckData, setCreatePendingCheckData] = useState({
    check_type: '',
    description: ''
  });
  const [creatingPendingCheck, setCreatingPendingCheck] = useState(false);

  // 对话相关状态
  const [conversations, setConversations] = useState([]);
  const [conversationsLoading, setConversationsLoading] = useState(false);
  const [conversationsError, setConversationsError] = useState('');
  const [showConversations, setShowConversations] = useState(false);

  // 新增状态用于段落编辑
  const [editingSection, setEditingSection] = useState(null); // 当前正在编辑的段落索引
  const [sectionContent, setSectionContent] = useState(''); // 当前编辑段落的内容
  const [parsedSections, setParsedSections] = useState([]); // 解析后的段落数组
  const [isPreviewMode, setIsPreviewMode] = useState(false); // 实时预览模式

  // 解析markdown内容为段落
  const parseMarkdownSections = (content) => {
    if (!content || typeof content !== 'string') {
      return [];
    }

    const lines = content.split('\n');
    const sections = [];
    let currentSection = null;
    let currentContent = [];
    let currentTitleLine = '';

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      // 检查是否是h2标题
      if (line.startsWith('## ')) {
        // 保存上一个段落
        if (currentSection) {
          sections.push({
            title: currentSection,
            titleLine: currentTitleLine,
            content: currentContent.join('\n').trim(),
            startIndex: sections.length
          });
        }

        // 开始新段落
        currentSection = line.substring(3).trim(); // 去掉 "## "
        currentTitleLine = line; // 保存完整的标题行
        currentContent = []; // 不包含标题行，只包含内容
      } else {
        // 添加到当前段落内容
        currentContent.push(line);
      }
    }

    // 保存最后一个段落
    if (currentSection) {
      sections.push({
        title: currentSection,
        titleLine: currentTitleLine,
        content: currentContent.join('\n').trim(),
        startIndex: sections.length
      });
    }

    // 如果没有h2标题，将整个内容作为一个段落
    if (sections.length === 0 && content.trim()) {
      sections.push({
        title: t('reports.entireReport'),
        titleLine: '',
        content: content.trim(),
        startIndex: 0
      });
    }

    return sections;
  };

  // 重新组合段落内容
  const reassembleSections = (sections) => {
    return sections.map(section => {
      if (section.titleLine) {
        // 如果有标题行，将标题行和内容组合
        return section.titleLine + '\n' + section.content;
      } else {
        // 如果没有标题行（整个报告的情况），只返回内容
        return section.content;
      }
    }).join('\n\n');
  };

  // 开始编辑段落
  const startEditingSection = (sectionIndex) => {
    const section = parsedSections[sectionIndex];
    if (section) {
      setEditingSection(sectionIndex);
      setSectionContent(section.content);
    }
  };

  // 保存段落编辑
  const saveSectionEdit = async () => {
    if (editingSection === null) return;

    try {
      // 更新段落内容
      const updatedSections = [...parsedSections];
      updatedSections[editingSection] = {
        ...updatedSections[editingSection],
        content: sectionContent
      };

      // 重新组合完整内容
      const newContent = reassembleSections(updatedSections);

      // 更新状态
      setReportContent(newContent);
      setParsedSections(updatedSections);

      // 自动保存到服务器
      await updateReportContent(id, newContent);

      // 关闭编辑模式
      setEditingSection(null);
      setSectionContent('');

      setSuccessMessage(t('reports.sectionUpdateSuccess'));
      setTimeout(() => setSuccessMessage(''), 3000);

    } catch (error) {
      console.error('保存段落编辑失败:', error);
      setError(t('reports.sectionUpdateError') + ': ' + (error.response?.data?.error || t('common.unknownError')));
    }
  };

  // 取消段落编辑
  const cancelSectionEdit = () => {
    setEditingSection(null);
    setSectionContent('');
    setIsPreviewMode(false);
  };

  const buildPatientInfoForReport = async (visitData, reportData = report) => {
    let patientData = null;
    if (visitData?.patient_id) {
      try {
        patientData = await getPatientById(visitData.patient_id);
      } catch (patientError) {
        console.warn('获取患者信息失败，将使用报告/就诊信息降级生成:', patientError);
      }
    }

    return buildReportPatientInfo({
      patient: patientData,
      visit: visitData,
      report: reportData
    });
  };

  // 检查是否还有待审核的检查项目
  const hasPendingChecks = () => {
    return pendingChecks && pendingChecks.some(check => check.status === 'pending');
  };

  // 检查是否可以添加新的待检查项目
  const canAddPendingCheck = () => {
    return report && 
           report.report_type === 'proposal' && 
           report.status === 'pending';
  };

  // 判断待检查项是否是用户创建的（通过review_note字段判断）
  const isUserCreatedCheck = (pendingCheck) => {
    // 如果review_note有值且不为空字符串，说明是用户创建的
    return pendingCheck.review_note && pendingCheck.review_note.trim() !== '';
  };

  // 切换预览模式
  const togglePreviewMode = () => {
    setIsPreviewMode(!isPreviewMode);
  };

  // 当reportContent变化时，重新解析段落
  useEffect(() => {
    const sections = parseMarkdownSections(reportContent);
    setParsedSections(sections);
  }, [reportContent, t]);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const data = await getReportById(id);
        setReport(data);

        console.log('report data', data);

        // 判断content是否存在
        let hasContent = false;

        // 如果病历内容是字符串，直接使用
        if (typeof data.content === 'string' && data.content.trim() !== '') {
          setReportContent(data.content);
          hasContent = true;
        } else if (data.content && typeof data.content === 'object' && Object.keys(data.content).length > 0) {
          // 如果病历内容是非空对象，转换为JSON字符串
          setReportContent(JSON.stringify(data.content, null, 2));
          hasContent = true;
        } else {
          // 如果病历内容为空，设置为空字符串
          setReportContent('');
          hasContent = false;
        }

        // 获取相关的检查项和对话消息
        if (data.visit_id) {
          const checksData = await fetchChecks(data.visit_id); // 👈 获取返回的数据
          fetchConversations(data.visit_id);
          fetchAppointmentOrders(data.visit_id);
          
          // 获取待检查项目 - 需要 await 以确保数据加载完成，并获取返回值
          const pendingChecksData = await fetchPendingChecks(data.visit_id);

          // 只有在内容为空且状态为pending时才需要获取visit信息以生成报告
          if (!hasContent && data.status === 'pending') {
            try {
              const visitData = await getVisitById(data.visit_id);
              setVisit(visitData);

              // 延迟一点执行，确保组件已完全加载
              setTimeout(async () => {
                const patientInfo = await buildPatientInfoForReport(visitData, data);
                
                // 如果是 final 类型，还需要传递被拒绝的待检查项
                let rejectedPendingChecksData = null;
                if (data.report_type === 'final') {
                  // 从获取到的待检查项数据中筛选被拒绝的项
                  rejectedPendingChecksData = pendingChecksData?.filter(check => check.status === 'rejected') || [];
                  console.log('初始化生成报告 - 被拒绝的待检查项:', rejectedPendingChecksData.length, '项');
                }
                
                await autoGenerateReport(visitData.conversation_id, data.report_type, patientInfo, checksData, rejectedPendingChecksData); // 👈 传入checksData和rejectedPendingChecksData
              }, 500);
            } catch (visitError) {
              console.error(`获取就诊信息失败:`, visitError);
              setError(t('reports.fetchVisitError') + ': ' + (visitError.response?.data?.error || t('common.unknownError')));
            }
          } else {
            // 即使content存在，也获取visit信息，但不生成报告
            try {
              const visitData = await getVisitById(data.visit_id);
              setVisit(visitData);
            } catch (visitError) {
              console.error(`获取就诊信息失败:`, visitError);
              // 这里不设置错误，因为即使没有visit信息，也已经有report内容了
            }
          }
        } else {
          // 如果没有visit_id，直接设为ready
          setChecksReady(true);
        }

        setLoading(false);
      } catch (error) {
        console.error('获取报告详情失败:', error);
        setError(t('reports.fetchReportError') + ': ' + (error.response?.data?.error || t('common.unknownError')));
        setChecksReady(true); // 即使出错也设为ready，避免按钮永远不显示
        setLoading(false);
      }
    };

    fetchReport();
  }, [id, t]);

  // 获取检查项列表
  const fetchChecks = async (visitId) => {
    if (!visitId) {
      setChecksError(t('reports.noVisitId'));
      setChecksLoading(false);
      setChecksReady(true); // 没有visitId时也设为ready
      return [];
    }

    try {
      setChecksLoading(true);
      setChecksReady(false); // 开始加载时设为false
      const data = await getChecksByVisitId(visitId);
      setChecks(data || []);
      setChecksError('');
      return data || []; // 👈 返回数据
    } catch (error) {
      console.error(`获取就诊ID${visitId}的检查项失败:`, error);
      setChecksError(t('reports.fetchChecksError') + ': ' + (error.response?.data?.error || error.message || t('common.unknownError')));
      return []; // 👈 出错时返回空数组
    } finally {
      setChecksLoading(false);
      setChecksReady(true); // 完成加载后设为true
    }
  };

  // 获取待检查项目列表
  const fetchPendingChecks = async (visitId) => {
    if (!visitId) {
      setPendingChecksError(t('reports.noVisitId'));
      setPendingChecksLoading(false);
      return [];
    }

    try {
      setPendingChecksLoading(true);
      const data = await getPendingChecksByVisitId(visitId);
      setPendingChecks(data || []);
      setPendingChecksError('');
      return data || []; // 👈 返回数据
    } catch (error) {
      console.error(`获取就诊ID${visitId}的待检查项失败:`, error);
      setPendingChecksError(t('reports.fetchPendingChecksError') + ': ' + (error.response?.data?.error || error.message || t('common.unknownError')));
      return []; // 👈 出错时返回空数组
    } finally {
      setPendingChecksLoading(false);
    }
  };

  const fetchAppointmentOrders = async (visitId) => {
    if (!visitId) {
      setAppointmentOrders([]);
      return [];
    }

    try {
      const [sourceOrders, claimOrders] = await Promise.all([
        getAppointmentOrders({ source_visit_id: visitId }),
        getAppointmentOrders({ claim_visit_id: visitId })
      ]);

      const merged = [...(sourceOrders || []), ...(claimOrders || [])];
      const uniqueOrders = merged.filter((order, index, array) => array.findIndex((candidate) => candidate.id === order.id) === index);
      setAppointmentOrders(uniqueOrders);
      return uniqueOrders;
    } catch (requestError) {
      console.error(`获取就诊ID${visitId}关联预约单失败:`, requestError);
      setAppointmentOrders([]);
      return [];
    }
  };

  // 审核待检查项目
  const handleReviewPendingCheck = async (pendingCheckId, status, note = '') => {
    try {
      setReviewSubmitting(true);
      await reviewPendingCheck(pendingCheckId, {
        status: status,
        note: note
      });
      
      // 刷新待检查项目列表
      if (report && report.visit_id) {
        fetchPendingChecks(report.visit_id);
      }
      
      setReviewingPendingCheck(null);
      setSuccessMessage(t('reports.pendingCheckReviewSuccess'));
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('审核待检查项目失败:', error);
      setError(t('reports.pendingCheckReviewError') + ': ' + (error.response?.data?.error || t('common.unknownError')));
    } finally {
      setReviewSubmitting(false);
    }
  };

  // 创建待检查项目
  const handleCreatePendingCheck = async () => {
    if (!createPendingCheckData.check_type || !createPendingCheckData.description) {
      setError(t('reports.createPendingCheckValidationError'));
      return;
    }

    if (!report || !report.visit_id) {
      setError(t('reports.noVisitIdForPendingCheck'));
      return;
    }

    try {
      setCreatingPendingCheck(true);
      setError('');

      // 将用户ID填入review_note字段以标识这是用户创建的待检查项
      await createPendingCheck({
        visit_id: report.visit_id,
        check_type: createPendingCheckData.check_type,
        description: createPendingCheckData.description,
        review_note: currentUser?.id ? String(currentUser.id) : 'user_created'
      });

      // 刷新待检查项目列表
      fetchPendingChecks(report.visit_id);
      
      // 重置表单和关闭对话框
      setCreatePendingCheckData({
        check_type: '',
        description: ''
      });
      setShowCreatePendingCheck(false);
      
      setSuccessMessage(t('reports.createPendingCheckSuccess'));
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('创建待检查项目失败:', error);
      setError(t('reports.createPendingCheckError') + ': ' + (error.response?.data?.error || t('common.unknownError')));
    } finally {
      setCreatingPendingCheck(false);
    }
  };

  // 删除待检查项目
  const handleDeletePendingCheck = async (pendingCheckId) => {
    // 弹出确认对话框
    if (!window.confirm(t('reports.confirmDeletePendingCheckMessage'))) {
      return;
    }

    try {
      setReviewSubmitting(true);
      await deletePendingCheck(pendingCheckId);
      
      // 刷新待检查项目列表
      if (report && report.visit_id) {
        fetchPendingChecks(report.visit_id);
      }
      
      setSuccessMessage(t('reports.deletePendingCheckSuccess'));
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('删除待检查项目失败:', error);
      setError(t('reports.deletePendingCheckError') + ': ' + (error.response?.data?.error || t('common.unknownError')));
    } finally {
      setReviewSubmitting(false);
    }
  };

  const addAppointmentDraft = () => {
    setAppointmentDrafts((current) => [...current, { check_type: '', description: '' }]);
  };

  const updateAppointmentDraft = (index, field, value) => {
    setAppointmentDrafts((current) =>
      current.map((draft, draftIndex) => (
        draftIndex === index ? { ...draft, [field]: value } : draft
      ))
    );
  };

  const removeAppointmentDraft = (index) => {
    setAppointmentDrafts((current) => {
      if (current.length === 1) {
        return [{ check_type: '', description: '' }];
      }
      return current.filter((_, draftIndex) => draftIndex !== index);
    });
  };

  // 获取对话消息列表
  const fetchConversations = async (visitId) => {
    if (!visitId) {
      setConversationsError(t('reports.noVisitId'));
      return;
    }

    try {
      setConversationsLoading(true);
      setConversationsError('');
      const data = await getConversationMessagesByVisitId(visitId);

      // 过滤掉以"人类医生已确认如下报告"开头的消息
      const filteredMessages = (data.messages || []).filter(message => {
        return !message.content || !message.content.startsWith('人类医生已确认如下报告');
      });

      setConversations(filteredMessages);
    } catch (error) {
      console.error(`获取就诊ID${visitId}的对话消息失败:`, error);
      setConversationsError(t('reports.fetchConversationError') + ': ' + (error.response?.data?.error || error.message || t('common.unknownError')));
    } finally {
      setConversationsLoading(false);
    }
  };

  // 处理审核操作的通用函数
  const handleReview = async (action) => {
    console.log('Review action:', action); // 调试用
    
    // 转换为对应的状态值
    const reviewStatus = action === 'approve' ? 'approved' : 'rejected';
    
    setSubmitting(true);
    setError('');
    setSuccessMessage('');

    try {
      // 先更新病历内容
      await updateReportContent(id, reportContent);

      const appointmentOrdersPayload = (
        reviewStatus === 'approved' && report?.report_type === 'final'
          ? appointmentDrafts
            .map((draft) => ({
              check_type: draft.check_type.trim(),
              description: draft.description.trim()
            }))
            .filter((draft) => draft.check_type)
          : []
      );

      // 然后提交审核结果
      await reviewReport(id, {
        status: reviewStatus,
        note,
        content: reportContent,
        appointment_orders: appointmentOrdersPayload
      });

      setSuccessMessage(t('reports.reviewSuccess'));

      // 特殊逻辑：当proposal类型的报告被approved且满足以下条件之一时，自动创建final报告：
      // 1. 不存在待检查项
      // 2. 所有待检查项都已审核完毕（没有pending状态）且不存在approved状态的待检查项（不需要创建检查结果）
      const canCreateFinalReport = !pendingChecks || 
                                    pendingChecks.length === 0 || 
                                    !pendingChecks.some(check => check.status === 'pending' || check.status === 'approved');
      
      if (action === 'approve' && 
          report && 
          report.report_type === 'proposal' && 
          canCreateFinalReport) {
        
        try {
          // 创建final类型的报告
          const finalReport = await createReport(report.visit_id, 'final', report.conversation_id);
          
          setSuccessMessage(
            t('reports.reviewSuccess') + ' ' + 
            t('reports.finalReportAutoCreated', { reportId: finalReport.id })
          );
        } catch (finalReportError) {
          console.warn('自动创建final报告失败:', finalReportError);
          // 不影响主要审核流程，只记录警告
          setSuccessMessage(
            t('reports.reviewSuccess') + ' ' + 
            t('reports.finalReportCreationFailed')
          );
        }
      }

      // 延迟2秒后跳转回列表页
      setTimeout(() => {
        navigate('/reports');
      }, 2000);
    } catch (error) {
      console.error('审核报告失败:', error);
      setError(t('reports.reviewError') + ': ' + (error.response?.data?.error || t('common.unknownError')));
    } finally {
      setSubmitting(false);
    }
  };

  // 兼容原有的表单提交处理（备用）
  const handleSubmit = async (e) => {
    e.preventDefault();
    // 默认为reject，但这个函数现在主要作为备用
    await handleReview('reject');
  };

  // 自动生成报告内容的函数
  const autoGenerateReport = async (conversationId, reportType = 'proposal', patientInfo = {}, passedChecksData = null, passedRejectedPendingChecks = null) => {
    if (!conversationId) {
      setError(t('reports.noConversationIdForGeneration'));
      return;
    }

    setGenerating(true);
    setError('');
    setSuccessMessage(t('reports.generating'));

    try {
      // 如果是 final 报告类型，需要获取检查项结果
      let checksData = null;
      let rejectedPendingChecksData = null;
      
      if (reportType === 'final') {
        // 优先使用传入的检查项数据
        if (passedChecksData && passedChecksData.length > 0) {
          checksData = passedChecksData;
        } else {
          // 使用页面上已经获取的检查项数据
          checksData = checks;
          
          // 如果检查项数据为空，尝试重新获取
          if (!checksData || checksData.length === 0) {
            if (report && report.visit_id) {
              try {
                checksData = await getChecksByVisitId(report.visit_id);
              } catch (error) {
                console.warn('获取检查项数据失败，将继续生成报告但不包含检查结果:', error);
                checksData = [];
              }
            }
          }
        }
        
        // 处理被拒绝的待检查项
        if (passedRejectedPendingChecks && passedRejectedPendingChecks.length > 0) {
          rejectedPendingChecksData = passedRejectedPendingChecks;
        } else {
          // 从页面上已经获取的待检查项中筛选出被拒绝的
          if (pendingChecks && pendingChecks.length > 0) {
            rejectedPendingChecksData = pendingChecks.filter(check => check.status === 'rejected');
          }
        }
        
        // 打印调试信息
        console.log('生成final报告 - 检查项数据:', checksData?.length || 0, '项');
        console.log('生成final报告 - 被拒绝的待检查项:', rejectedPendingChecksData?.length || 0, '项');
        if (rejectedPendingChecksData && rejectedPendingChecksData.length > 0) {
          console.log('被拒绝的待检查项详情:', rejectedPendingChecksData);
        }
      }

      const content = await generateReportContent(conversationId, reportType, patientInfo, checksData, rejectedPendingChecksData);
      setReportContent(content);
      setSuccessMessage(t('reports.generationSuccess'));

      // 自动保存生成的病历内容
      await updateReportContent(id, content);
    } catch (error) {
      console.error('自动生成病历内容失败:', error);
      setError(t('reports.generationError') + ': ' + (error.response?.data?.error || error.message || t('common.unknownError')));
    } finally {
      setGenerating(false);
    }
  };

  // 导出 Markdown 文件
  const handleExportMarkdown = () => {
    if (!reportContent || reportContent.trim() === '') {
      setError(t('reports.noContentToExport'));
      setTimeout(() => setError(''), 3000);
      return;
    }

    try {
      // 创建 Blob 对象
      const blob = new Blob([reportContent], { type: 'text/markdown;charset=utf-8' });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // 生成文件名：report_[报告ID]_[时间戳].md
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
      link.download = `report_${id}_${timestamp}.md`;
      
      // 触发下载
      document.body.appendChild(link);
      link.click();
      
      // 清理
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      setSuccessMessage(t('reports.exportSuccess'));
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('导出Markdown文件失败:', error);
      setError(t('reports.exportError'));
      setTimeout(() => setError(''), 3000);
    }
  };

  // 导出 PDF 文件（使用浏览器打印功能）
  const handleExportPDF = () => {
    if (!reportContent || reportContent.trim() === '') {
      setError(t('reports.noContentToExport'));
      setTimeout(() => setError(''), 3000);
      return;
    }

    try {
      // 创建一个新窗口用于打印
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        setError('无法打开打印窗口，请检查浏览器弹窗设置');
        setTimeout(() => setError(''), 3000);
        return;
      }

      // 渲染Markdown为HTML
      const markdownContent = document.querySelector('.markdown-content');
      const htmlContent = markdownContent ? markdownContent.innerHTML : reportContent;

      // 生成打印页面的HTML
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <title>报告 #${id} - ${timestamp}</title>
          <style>
            body {
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Microsoft YaHei", "微软雅黑";
              line-height: 1.6;
              color: #333;
              max-width: 800px;
              margin: 20px auto;
              padding: 20px;
            }
            h1 {
              color: #2c3e50;
              font-size: 1.8em;
              margin-top: 1.5em;
              margin-bottom: 0.8em;
              padding-bottom: 0.3em;
              border-bottom: 1px solid #eaecef;
            }
            h2 {
              color: #3498db;
              font-size: 1.5em;
              margin-top: 1.2em;
              margin-bottom: 0.6em;
            }
            h3 {
              color: #2980b9;
              font-size: 1.3em;
              margin-top: 1em;
              margin-bottom: 0.5em;
            }
            p {
              margin-top: 0.5em;
              margin-bottom: 1em;
            }
            ul, ol {
              margin-top: 0.5em;
              margin-bottom: 1em;
              padding-left: 2em;
            }
            li {
              margin-bottom: 0.3em;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              margin: 1em 0;
            }
            table th {
              background-color: #f8f9fa;
              border: 1px solid #dfe2e5;
              padding: 0.5em 1em;
              font-weight: 600;
            }
            table td {
              border: 1px solid #dfe2e5;
              padding: 0.5em 1em;
            }
            @media print {
              body {
                margin: 0;
                padding: 15mm;
              }
            }
          </style>
        </head>
        <body>
          <h1>病历报告 #${id}</h1>
          <p style="color: #666; font-size: 0.9em;">生成时间: ${new Date().toLocaleString('zh-CN')}</p>
          <hr style="margin: 20px 0; border: none; border-top: 2px solid #eee;">
          ${htmlContent}
        </body>
        </html>
      `);
      printWindow.document.close();

      // 等待内容加载完成后触发打印
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
        }, 250);
      };

      setSuccessMessage('请在打印对话框中选择"保存为PDF"');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('导出PDF失败:', error);
      setError('导出PDF失败: ' + error.message);
      setTimeout(() => setError(''), 3000);
    }
  };

  // 导出 DOCX 文件
  const handleExportDOCX = () => {
    if (!reportContent || reportContent.trim() === '') {
      setError(t('reports.noContentToExport'));
      setTimeout(() => setError(''), 3000);
      return;
    }

    try {
      // 将Markdown转换为简单的HTML格式
      let htmlContent = reportContent
        // 标题转换
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        // 粗体和斜体
        .replace(/\*\*\*(.*?)\*\*\*/g, '<b><i>$1</i></b>')
        .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
        .replace(/\*(.*?)\*/g, '<i>$1</i>')
        // 列表
        .replace(/^\* (.*$)/gim, '<li>$1</li>')
        .replace(/^- (.*$)/gim, '<li>$1</li>')
        .replace(/^\d+\. (.*$)/gim, '<li>$1</li>')
        // 段落
        .replace(/\n\n/g, '</p><p>')
        // 换行
        .replace(/\n/g, '<br/>');

      // 包装在段落标签中
      htmlContent = '<p>' + htmlContent + '</p>';
      
      // 包装列表项
      htmlContent = htmlContent.replace(/(<li>.*?<\/li>)/gs, (match) => {
        return '<ul>' + match + '</ul>';
      });

      // 创建完整的HTML文档
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
      const fullHTML = `
        <!DOCTYPE html>
        <html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
        <head>
          <meta charset='utf-8'>
          <title>报告 #${id}</title>
          <style>
            body { font-family: 'Microsoft YaHei', Arial, sans-serif; line-height: 1.6; }
            h1 { color: #2c3e50; font-size: 24pt; margin-top: 12pt; margin-bottom: 6pt; }
            h2 { color: #3498db; font-size: 18pt; margin-top: 10pt; margin-bottom: 5pt; }
            h3 { color: #2980b9; font-size: 14pt; margin-top: 8pt; margin-bottom: 4pt; }
            p { margin-top: 6pt; margin-bottom: 6pt; }
            ul, ol { margin-top: 6pt; margin-bottom: 6pt; }
            li { margin-bottom: 3pt; }
          </style>
        </head>
        <body>
          <h1>病历报告 #${id}</h1>
          <p style="color: #666; font-size: 10pt;">生成时间: ${new Date().toLocaleString('zh-CN')}</p>
          <hr/>
          ${htmlContent}
        </body>
        </html>
      `;

      // 创建Blob对象
      const blob = new Blob(['\ufeff', fullHTML], {
        type: 'application/msword'
      });

      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `report_${id}_${timestamp}.doc`;

      // 触发下载
      document.body.appendChild(link);
      link.click();

      // 清理
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setSuccessMessage('报告已导出为Word文档格式');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('导出DOCX失败:', error);
      setError('导出Word文档失败: ' + error.message);
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleGenerateReport = async () => {
    if (!report) {
      setError(t('reports.noReportData'));
      return;
    }

    // 如果是 final 类型报告，需要先确保检查项和待检查项数据已加载
    let checksData = null;
    let rejectedPendingChecksData = null;
    
    if (report.report_type === 'final' && report.visit_id) {
      // 重新获取最新的检查项数据
      try {
        checksData = await getChecksByVisitId(report.visit_id);
        console.log('handleGenerateReport - 获取到检查项数据:', checksData?.length || 0, '项');
      } catch (error) {
        console.warn('获取检查项数据失败:', error);
        checksData = checks || []; // 如果获取失败，使用state中的数据
      }
      
      // 重新获取最新的待检查项数据
      try {
        const allPendingChecks = await getPendingChecksByVisitId(report.visit_id);
        // 筛选出被拒绝的待检查项
        rejectedPendingChecksData = allPendingChecks?.filter(check => check.status === 'rejected') || [];
        console.log('handleGenerateReport - 获取到被拒绝的待检查项:', rejectedPendingChecksData.length, '项');
      } catch (error) {
        console.warn('获取待检查项数据失败:', error);
        // 如果获取失败，使用state中的数据
        rejectedPendingChecksData = pendingChecks?.filter(check => check.status === 'rejected') || [];
      }
    }

    // 如果visit没有加载，尝试重新加载
    if (!visit) {
      try {
        const visitData = await getVisitById(report.visit_id);
        setVisit(visitData);
        const patientInfo = await buildPatientInfoForReport(visitData, report);
        // 使用autoGenerateReport函数生成报告，传入检查项数据和被拒绝的待检查项
        await autoGenerateReport(visitData.conversation_id, report.report_type, patientInfo, checksData, rejectedPendingChecksData);
      } catch (error) {
        console.error('获取就诊信息失败:', error);
        setError(t('reports.fetchVisitError') + ': ' + (error.response?.data?.error || t('common.unknownError')));
      }
      return;
    }

    // 从已加载的visit信息中提取患者信息
    const patientInfo = await buildPatientInfoForReport(visit, report);

    // 使用已加载的visit信息调用autoGenerateReport，传入检查项数据和被拒绝的待检查项
    await autoGenerateReport(visit.conversation_id, report.report_type, patientInfo, checksData, rejectedPendingChecksData);
  };

  const formatDate = (dateString) => {
    if (!dateString) return t('reports.notSpecified');
    const date = new Date(dateString);
    return date.toLocaleString(isZh ? 'zh-CN' : 'en-US');
  };

  const toggleViewMode = () => {
    setViewMode(viewMode === 'edit' ? 'preview' : 'edit');
  };

  const getCheckTypeName = (type) => {
    if (!type) return t('common.unknown');
    
    // 处理 CHECKTYPES.XXX 格式的类型
    let normalizedType = type;
    if (type.startsWith('CHECKTYPES.')) {
      const typeKey = type.replace('CHECKTYPES.', '').toLowerCase();
      // 映射常见的检查类型
      const typeMapping = {
        'lab': 'lab',
        'quick': 'quick',
        'body': 'body',
        'scan': 'scan',
        'tissue': 'tissue',
        'scope': 'scope',
        'other': 'other',
        'pure_throat': 'throat',
        'physical': 'physical',
        'vital_signs': 'vital_signs',
        'urine': 'urine',
        'blood': 'blood',
        'ct': 'ct',
        'xray': 'xray',
        'ultrasound': 'ultrasound',
        'ecg': 'ecg',
        'mri': 'mri',
        'pathology': 'pathology',
        'endoscopy': 'endoscopy',
        'function': 'common',
        'heartbeat': 'heartbeat',
        'respiratory': 'respiratory',
        'temperature': 'temperature',
        'blood_pressure': 'blood'
      };
      normalizedType = typeMapping[typeKey] || typeKey;
    }
    
    return t(`checkTypes.${normalizedType}`) || type;
  };

  const toggleCheckDetails = (index) => {
    const detailsElement = document.getElementById(`check-details-${index}`);
    if (detailsElement) {
      const isVisible = detailsElement.style.display !== 'none';
      detailsElement.style.display = isVisible ? 'none' : 'block';
    }
  };

  // 格式化对话消息时间
  const formatConversationTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  // 检查消息是否包含真正的工具调用XML标签（排除记录性标签）
  const hasToolCallXML = (content) => {
    if (!content) return false;
    // 只有这些标签才是真正的工具调用
    const toolCallPatterns = [
      /<exam_order>/,
      /<long_exam_order>/,
      /<exam_pending>/,
      /<consultation_finish>/
    ];
    return toolCallPatterns.some(pattern => pattern.test(content));
  };

  // 检查消息是否包含记录性XML标签
  const hasRecordingXML = (content) => {
    if (!content) return false;
    const recordingPatterns = [
      /<subjective>/,
      /<objective>/,
      /<assessment>/,
      /<plan>/,
      /<diagnosis>/,
      /<treatment>/,
      /<end>/
    ];
    return recordingPatterns.some(pattern => pattern.test(content));
  };

  // 清理消息内容，移除TTS标签但保留内容，移除universal_medical标签及其内容
  const cleanMessageContent = (content) => {
    if (!content) return content;
    
    let cleanedContent = content;
    
    // 移除 <tts> 标签但保留其内容
    cleanedContent = cleanedContent.replace(/<tts>(.*?)<\/tts>/g, '$1');
    
    // 完全移除 <universal_medical> 标签及其内容
    cleanedContent = cleanedContent.replace(/<universal_medical[^>]*>[\s\S]*?<\/universal_medical>/g, '');
    
    // 清理多余的换行符
    cleanedContent = cleanedContent.replace(/\n\s*\n\s*\n/g, '\n\n').trim();
    
    return cleanedContent;
  };

  // 格式化工具消息内容，提供国际化支持
  const formatToolMessageContent = (content) => {
    if (!content) return content;

    // 首先清理消息内容，移除不需要显示的XML标签
    let translatedContent = cleanMessageContent(content);

    // 处理检查类型相关的消息
    if (translatedContent.includes('检查类型：')) {
      translatedContent = translatedContent.replace(/检查类型：\s*(\w+)/g, (match, checkType) => {
        return `${t('reports.checkType')}: ${getCheckTypeName(checkType)}`;
      });
    }

    if (translatedContent.includes('检查结果明细：')) {
      translatedContent = translatedContent.replace(/检查结果明细：/g, t('reports.checkResultDetails'));
    }

    // 处理检查项目名称的翻译
    const examMappings = {
      '快速链球菌检测': t('reports.rapidStrepTest'),
      '全血细胞计数+分类计数': t('reports.completeBloodCountDiff'),
      '肺炎支原体抗体检测': t('reports.mycoplasmaPneumoniaeTest'),
      '血常规+C反应蛋白': t('reports.bloodCountCReactiveProtein'),
      '流感病毒抗原检测': t('reports.influenzaVirusAntigenTest'),
      '新冠病毒抗原检测': t('reports.covidAntigenTest'),
      '六项呼吸道病原体核酸检测': t('reports.respiratoryPathogenNucleicAcid'),
      '尿液分析': t('reports.urineAnalysis'),
      '粪常规': t('reports.fecalRoutine'),
      '腹部触诊': t('reports.abdominalPalpation'),
      '体温测量': t('reports.temperatureMeasurement'),
      '血压测量': t('reports.bloodPressureMeasurement'),
      '心肺听诊': t('reports.cardiopulmonaryAuscultation'),
      '咽部检查': t('reports.throatExamination')
    };

    // 替换检查项目名称
    Object.entries(examMappings).forEach(([chinese, translation]) => {
      // 转义正则表达式特殊字符，特别是加号
      const escapedChinese = chinese.replace(/[+\-\[\]{}()*?.,\\^$|#\s]/g, '\\$&');
      const regex = new RegExp(escapedChinese, 'g');
      translatedContent = translatedContent.replace(regex, translation);
    });

    // 处理其他常见的中文短语
    const commonPhrases = {
      'consent to the examination': t('reports.consentToExamination'),
      '同意检查': t('reports.consentToExamination'),
      '检查同意': t('reports.consentToExamination'),
      'Positive': t('reports.positive'),
      'Negative': t('reports.negative'),
      'Normal': t('reports.normal'),
      'Abnormal': t('reports.abnormal'),
      '阳性': t('reports.positive'),
      '阴性': t('reports.negative'),
      '正常': t('reports.normal'),
      '异常': t('reports.abnormal'),
      '问诊结束': t('reports.consultationFinish')
    };

    Object.entries(commonPhrases).forEach(([phrase, translation]) => {
      const regex = new RegExp(phrase, 'gi');
      translatedContent = translatedContent.replace(regex, translation);
    });

    return translatedContent;
  };

  // 提取和格式化工具调用内容（只处理真正的工具调用标签）
  const formatToolCallContent = (content) => {
    if (!content) return content;

    // 先清理TTS标签，然后提取XML标签内容并格式化
    const cleanedContent = cleanMessageContent(content);
    return cleanedContent
      .replace(/<exam_order>(.*?)<\/exam_order>/g, (match, examText) => `🔬 ${t('reports.examRequest')}: ${getExamTitle(examText)}`)
      .replace(/<long_exam_order>(.*?)<\/long_exam_order>/g, (match, examText) => `🔬 ${t('reports.detailedExamRequest')}: ${getExamTitle(examText)}`)
      .replace(/<exam_pending>(.*?)<\/exam_pending>/g, (match, examText) => `⏳ ${t('reports.examPending')}: ${getExamTitle(examText)}`)
      .replace(/<consultation_finish>(.*?)<\/consultation_finish>/g, (match, text) => `✅ ${t('reports.consultationFinish')}: ${getEndTitle(text)}`);
  };

  // 格式化记录性标签内容（用于在助手消息中突出显示）
  const formatRecordingContent = (content) => {
    if (!content) return content;

    const cleanedContent = cleanMessageContent(content);
    
    // 首先提取所有的XML标签内容
    let result = cleanedContent;
    const xmlReplacements = [
      { pattern: /<subjective>(.*?)<\/subjective>/gs, replacement: (match, text) => `<div style="margin: 4px 0 2px 0; padding: 8px; background-color: rgba(76, 175, 80, 0.1); border-left: 3px solid #4CAF50; border-radius: 4px;"><strong>📝 ${t('reports.subjectiveSymptom')}:</strong><br/>${text.trim()}</div>` },
      { pattern: /<objective>(.*?)<\/objective>/gs, replacement: (match, text) => `<div style="margin: 2px 0; padding: 8px; background-color: rgba(33, 150, 243, 0.1); border-left: 3px solid #2196F3; border-radius: 4px;"><strong>🔍 ${t('reports.objectiveExam')}:</strong><br/>${text.trim()}</div>` },
      { pattern: /<assessment>(.*?)<\/assessment>/gs, replacement: (match, text) => `<div style="margin: 2px 0; padding: 8px; background-color: rgba(255, 193, 7, 0.1); border-left: 3px solid #FFC107; border-radius: 4px;"><strong>💡 ${t('reports.assessment')}:</strong><br/>${text.trim()}</div>` },
      { pattern: /<plan>(.*?)<\/plan>/gs, replacement: (match, text) => `<div style="margin: 2px 0; padding: 8px; background-color: rgba(156, 39, 176, 0.1); border-left: 3px solid #9C27B0; border-radius: 4px;"><strong>📋 ${t('reports.plan')}:</strong><br/>${text.trim()}</div>` },
      { pattern: /<diagnosis>(.*?)<\/diagnosis>/gs, replacement: (match, text) => `<div style="margin: 2px 0; padding: 8px; background-color: rgba(244, 67, 54, 0.1); border-left: 3px solid #F44336; border-radius: 4px;"><strong>🏥 ${t('reports.diagnosis')}:</strong><br/>${text.trim()}</div>` },
      { pattern: /<treatment>(.*?)<\/treatment>/gs, replacement: (match, text) => `<div style="margin: 2px 0; padding: 8px; background-color: rgba(0, 188, 212, 0.1); border-left: 3px solid #00BCD4; border-radius: 4px;"><strong>💊 ${t('reports.treatment')}:</strong><br/>${text.trim()}</div>` },
      { pattern: /<end>(.*?)<\/end>/gs, replacement: () => '' }
    ];

    xmlReplacements.forEach(({ pattern, replacement }) => {
      result = result.replace(pattern, replacement);
    });

    // 清理卡片周围的换行符，确保卡片之间紧密相连
    result = result
      .replace(/\n+(<div[^>]*style="margin: [^"]*"[^>]*>)/g, '\n$1') // 卡片前只保留一个换行
      .replace(/(<\/div>)\n+(<div[^>]*style="margin: [^"]*"[^>]*>)/g, '$1$2') // 相邻卡片之间移除换行
      .replace(/\n{2,}/g, '\n') // 清理其他多余换行
      .trim();

    return result;
  };

  // 渲染对话消息
  const renderConversationMessage = (message, index) => {
    const isUser = message.role === 'user';
    const isTool = message.role === 'tool';
    const isAssistant = message.role === 'assistant';
    const hasXMLTags = hasToolCallXML(message.content);

    // 如果是tool消息，使用特殊布局
    if (isTool) {
      return (
        <div key={index} style={{
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <div style={{
            maxWidth: '80%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            {/* 系统消息时间戳 */}
            <div style={{
              fontSize: '12px',
              color: '#999',
              marginBottom: '8px',
              fontWeight: '500'
            }}>
              {t('reports.systemMessage')} | {formatConversationTime(message.created_at)}
            </div>

            {/* 系统消息气泡 */}
            <div style={{
              padding: '10px 16px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, rgba(108, 117, 125, 0.1) 0%, rgba(73, 80, 87, 0.15) 100%)',
              color: '#6c757d',
              border: '1px solid rgba(108, 117, 125, 0.2)',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
              fontSize: '14px',
              lineHeight: '1.4',
              textAlign: 'center',
              fontStyle: 'italic',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
                <path d="M9 9h6v6H9z" fill="currentColor" />
                <path d="M9 1v4M15 1v4M9 19v4M15 19v4M1 9h4M1 15h4M19 9h4M19 15h4" stroke="currentColor" strokeWidth="2" />
              </svg>
              {formatToolMessageContent(message.content)}
            </div>
          </div>
        </div>
      );
    }

    // 如果是包含真正工具调用XML标签的助手消息，需要特殊处理
    if (isAssistant && hasXMLTags) {
      // 分离普通文本和工具调用XML标签内容
      const lines = message.content.split('\n');
      const normalText = [];
      const toolCallLines = [];

      lines.forEach(line => {
        if (hasToolCallXML(line)) {
          toolCallLines.push(line);
        } else if (line.trim()) {
          normalText.push(line);
        }
      });

      return (
        <div key={index} style={{ marginBottom: '20px' }}>
          {/* 普通助手消息部分 */}
          {normalText.length > 0 && (
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              gap: '12px',
              marginBottom: '10px'
            }}>
              {/* 助手头像 */}
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #43d6c5 0%, #7ae5ba 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '14px',
                fontWeight: '600',
                flexShrink: 0
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="11" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
                  <circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="2" />
                  <path d="M12 7v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <circle cx="9" cy="16" r="1" fill="currentColor" />
                  <circle cx="15" cy="16" r="1" fill="currentColor" />
                </svg>
              </div>

              {/* 助手消息内容 */}
              <div style={{
                maxWidth: '70%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  fontSize: '12px',
                  color: '#666',
                  marginBottom: '6px',
                  fontWeight: '500'
                }}>
                  {t('reports.assistantMessage')} | {formatConversationTime(message.created_at)}
                </div>

                <div style={{
                  padding: '12px 16px',
                  borderRadius: '18px 18px 18px 4px',
                  background: 'rgba(250, 245, 236, 0.94)',
                  color: '#333',
                  border: '1px solid rgba(0, 0, 0, 0.1)',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  wordBreak: 'break-word',
                  lineHeight: '1.5',
                  textAlign: 'left'
                }}>
                  <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}
                  dangerouslySetInnerHTML={{
                    __html: formatRecordingContent(normalText.join('\n')).replace(/\n/g, '<br/>')
                  }}>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 工具调用XML标签部分（只有真正的工具调用才显示） */}
          {toolCallLines.length > 0 && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: normalText.length > 0 ? '5px' : '0'
            }}>
              <div style={{
                maxWidth: '80%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <div style={{
                  fontSize: '12px',
                  color: '#999',
                  marginBottom: '8px',
                  fontWeight: '500'
                }}>
                  {t('reports.toolCallMessage')}
                </div>

                <div style={{
                  padding: '10px 16px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.15) 100%)',
                  color: '#856404',
                  border: '1px solid rgba(255, 193, 7, 0.3)',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                  fontSize: '14px',
                  lineHeight: '1.4',
                  textAlign: 'left',
                  whiteSpace: 'pre-wrap'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                      <path d="M2 17l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                      <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                    </svg>
                    <div>{formatToolCallContent(toolCallLines.join('\n'))}</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }

    return (
      <div key={index} style={{
        marginBottom: '20px',
        display: 'flex',
        flexDirection: isUser ? 'row-reverse' : 'row',
        alignItems: 'flex-start',
        gap: '12px'
      }}>
        {/* 头像 */}
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          background: isUser
            ? 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)'
            : 'linear-gradient(135deg, #43d6c5 0%, #7ae5ba 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '14px',
          fontWeight: '600',
          flexShrink: 0
        }}>
          {isUser ? (
            // 用户头像 - 简笔画人物
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            // 助手头像 - 简笔画机器人
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="11" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
              <circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="2" />
              <path d="M12 7v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <circle cx="9" cy="16" r="1" fill="currentColor" />
              <circle cx="15" cy="16" r="1" fill="currentColor" />
            </svg>
          )}
        </div>

        {/* 消息内容 */}
        <div style={{
          maxWidth: '70%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: isUser ? 'flex-end' : 'flex-start'
        }}>
          {/* 消息头部信息 */}
          <div style={{
            fontSize: '12px',
            color: '#666',
            marginBottom: '6px',
            display: 'flex',
            flexDirection: isUser ? 'row-reverse' : 'row',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span style={{ fontWeight: '500' }}>
              {isUser ? t('reports.userMessage') : t('reports.assistantMessage')}
            </span>
            {message.name && isUser && (
              <>
                <span>|</span>
                <span>{message.name}</span>
              </>
            )}
            {message.age && isUser && (
              <>
                <span>|</span>
                <span>{message.age}</span>
              </>
            )}
            {message.sex && isUser && (
              <>
                <span>|</span>
                <span>{message.sex}</span>
              </>
            )}
            <span>|</span>
            <span>{formatConversationTime(message.created_at)}</span>
          </div>

          {/* 消息气泡 */}
          <div style={{
            padding: '12px 16px',
            borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
            background: isUser
              ? 'linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%)'
              : 'rgba(255, 255, 255, 0.95)',
            color: isUser ? 'white' : '#333',
            border: isUser ? 'none' : '1px solid rgba(0, 0, 0, 0.1)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            wordBreak: 'break-word',
            lineHeight: '1.5',
            textAlign: 'left'
          }}>
                      <div style={{
            whiteSpace: 'pre-wrap',
            textAlign: 'left'
          }} 
          dangerouslySetInnerHTML={{
            __html: hasRecordingXML(message.content) 
              ? formatRecordingContent(message.content).replace(/\n/g, '<br/>')
              : cleanMessageContent(message.content).replace(/\n/g, '<br/>')
          }}>
          </div>
          </div>
        </div>
      </div>
    );
  };

  // 按钮样式
  const getButtonStyle = (type = 'primary') => {
    const baseStyle = {
      padding: '12px 24px',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: '500',
      color: 'white',
      transition: 'all 0.3s ease',
      textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      overflow: 'hidden'
    };

    const styles = {
      primary: {
        ...baseStyle,
        color: '#0b1727',
        background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
        boxShadow: '0 12px 28px rgba(179, 143, 91, 0.26)'
      },
      success: {
        ...baseStyle,
        color: '#06231c',
        background: 'linear-gradient(135deg, #43d6c5 0%, #7ae5ba 100%)',
        boxShadow: '0 12px 28px rgba(79, 216, 164, 0.24)'
      },
      secondary: {
        ...baseStyle,
        background: 'linear-gradient(135deg, #173b59 0%, #23697f 100%)',
        boxShadow: '0 12px 28px rgba(16, 32, 51, 0.24)'
      },
      dark: {
        ...baseStyle,
        background: 'linear-gradient(135deg, #102033 0%, #07111d 100%)',
        boxShadow: '0 12px 28px rgba(7, 17, 29, 0.28)'
      }
    };

    return styles[type] || styles.primary;
  };

  const handleButtonHover = (e, isEnter) => {
    if (isEnter) {
      e.target.style.transform = 'translateY(-2px)';
      e.target.style.boxShadow = e.target.style.boxShadow.replace('0.4)', '0.6)');
    } else {
      e.target.style.transform = 'translateY(0)';
      e.target.style.boxShadow = e.target.style.boxShadow.replace('0.6)', '0.4)');
    }
  };

  // 渲染段落编辑模式
  const renderSectionEditMode = () => {
    if (editingSection === null) return null;

    const section = parsedSections[editingSection];
    if (!section) return null;

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '30px',
          width: '95%',
          maxWidth: '1400px',
          maxHeight: '85vh',
          overflow: 'auto',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            <h3 style={{
              margin: 0,
              fontSize: '1.5rem',
              fontWeight: '600',
              background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              {t('reports.editSection')}: {section.title}
            </h3>
            <button
              onClick={cancelSectionEdit}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666',
                padding: '5px'
              }}
            >
              ×
            </button>
          </div>

          {/* 显示固定的标题 */}
          {section.titleLine && (
            <div style={{
              marginBottom: '15px',
              padding: '10px',
              background: 'rgba(102, 126, 234, 0.05)',
              borderRadius: '6px',
              border: '1px solid rgba(102, 126, 234, 0.2)'
            }}>
              <div style={{
                fontSize: '12px',
                color: '#666',
                marginBottom: '5px'
              }}>
                {t('reports.sectionTitle')}:
              </div>
              <div style={{
                fontFamily: 'monospace',
                fontSize: '14px',
                color: '#333',
                fontWeight: '600'
              }}>
                {section.titleLine}
              </div>
            </div>
          )}

          {/* 编辑和预览区域 */}
          <div style={{
            display: 'flex',
            gap: '15px',
            minHeight: '500px'
          }}>
            {/* 编辑区域 */}
            <div style={{
              flex: isPreviewMode ? '1' : '1',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{
                fontSize: '12px',
                color: '#666',
                marginBottom: '5px',
                fontWeight: '500'
              }}>
                {t('reports.editContent')}
              </div>
              <textarea
                value={sectionContent}
                onChange={(e) => setSectionContent(e.target.value)}
                style={{
                  width: '100%',
                  minHeight: '460px',
                  fontFamily: 'monospace',
                  padding: '15px',
                  border: '2px solid rgba(102, 126, 234, 0.2)',
                  borderRadius: '8px',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  background: 'rgba(255, 248, 241, 0.88)',
                  color: '#1a202c',
                  transition: 'all 0.3s ease',
                  boxSizing: 'border-box',
                  resize: 'none',
                  flex: '1'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = 'rgba(102, 126, 234, 0.5)';
                  e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(102, 126, 234, 0.2)';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            {/* 预览区域 */}
            {isPreviewMode && (
              <div style={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column'
              }}>
                <div style={{
                  fontSize: '12px',
                  color: '#666',
                  marginBottom: '5px',
                  fontWeight: '500'
                }}>
                  {t('reports.livePreview')}
                </div>
                <div style={{
                  flex: '1',
                  border: '2px solid rgba(102, 126, 234, 0.2)',
                  borderRadius: '8px',
                  padding: '15px',
                  background: '#f9f9f9',
                  overflow: 'auto',
                  minHeight: '460px'
                }}>
                  {sectionContent ? (
                    <div className="markdown-content markdown-content--paper" style={{ textAlign: 'left' }}>
                      <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                          a: ({ node, href, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <a {...validProps} href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
                          },
                          pre: ({ node, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <pre {...validProps} style={{ margin: '1em 0' }}>{children}</pre>;
                          },
                          h1: ({ node, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <h1 {...validProps} style={{ textAlign: 'left', color: '#2c3e50', fontWeight: '700', fontSize: '1.8em', marginTop: '1.5em', marginBottom: '0.8em', paddingBottom: '0.3em', borderBottom: '1px solid #eaecef' }}>{children}</h1>;
                          },
                          h2: ({ node, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <h2 {...validProps} style={{ textAlign: 'left', color: '#3498db', fontWeight: '600', fontSize: '1.5em', marginTop: '1.2em', marginBottom: '0.6em' }}>{children}</h2>;
                          },
                          h3: ({ node, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <h3 {...validProps} style={{ textAlign: 'left', color: '#2980b9', fontWeight: '500', fontSize: '1.3em', marginTop: '1em', marginBottom: '0.5em' }}>{children}</h3>;
                          },
                          p: ({ node, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <p {...validProps} style={{ textAlign: 'left', marginTop: '0.5em', marginBottom: '1em', lineHeight: '1.6' }}>{children}</p>;
                          },
                          ul: ({ node, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <ul {...validProps} style={{ textAlign: 'left', marginTop: '0.5em', marginBottom: '1em', paddingLeft: '2em' }}>{children}</ul>;
                          },
                          ol: ({ node, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <ol {...validProps} style={{ textAlign: 'left', marginTop: '0.5em', marginBottom: '1em', paddingLeft: '2em' }}>{children}</ol>;
                          },
                          li: ({ node, children, ...props }) => {
                            const { ordered, ...validProps } = props;
                            return <li {...validProps} style={{ textAlign: 'left', marginBottom: '0.3em' }}>{children}</li>;
                          }
                        }}
                      >
                        {sectionContent}
                      </ReactMarkdown>
                    </div>
                  ) : (
                    <p style={{ color: '#999', textAlign: 'center', marginTop: '50px' }}>
                      {t('reports.previewPlaceholder')}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '20px'
          }}>
            {/* 预览切换按钮 */}
            <button
              onClick={togglePreviewMode}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 12px',
                border: '2px solid rgba(102, 126, 234, 0.3)',
                borderRadius: '6px',
                background: isPreviewMode ? 'rgba(102, 126, 234, 0.1)' : 'white',
                color: isPreviewMode ? '#667eea' : '#666',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = 'rgba(102, 126, 234, 0.5)';
                e.target.style.background = isPreviewMode ? 'rgba(102, 126, 234, 0.15)' : 'rgba(102, 126, 234, 0.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = 'rgba(102, 126, 234, 0.3)';
                e.target.style.background = isPreviewMode ? 'rgba(102, 126, 234, 0.1)' : 'white';
              }}
            >
              <span style={{ fontSize: '16px' }}>
                {isPreviewMode ? '👁️' : '👁️‍🗨️'}
              </span>
              {isPreviewMode ? t('reports.hidePreview') : t('reports.showPreview')}
            </button>

            {/* 操作按钮 */}
            <div style={{
              display: 'flex',
              gap: '15px'
            }}>
              <button
                onClick={cancelSectionEdit}
                style={{
                  ...getButtonStyle('dark'),
                  padding: '10px 20px',
                  fontSize: '14px'
                }}
                onMouseEnter={(e) => handleButtonHover(e, true)}
                onMouseLeave={(e) => handleButtonHover(e, false)}
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={saveSectionEdit}
                style={{
                  ...getButtonStyle('success'),
                  padding: '10px 20px',
                  fontSize: '14px'
                }}
                onMouseEnter={(e) => handleButtonHover(e, true)}
                onMouseLeave={(e) => handleButtonHover(e, false)}
              >
                {t('common.save')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 自定义ReactMarkdown组件，在h2标题旁添加编辑按钮
  const CustomH2 = ({ children, ...props }) => {
    const { ordered, ...validProps } = props;
    const titleText = children?.[0] || '';
    const sectionIndex = parsedSections.findIndex(section => section.title === titleText);

    return (
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <h2 {...validProps} style={{
          textAlign: 'left',
          color: '#3498db',
          fontWeight: '600',
          fontSize: '1.5em',
          marginTop: '1.2em',
          marginBottom: '0.6em',
          flex: 1
        }}>
          {children}
        </h2>
        {sectionIndex !== -1 && (
          <button
            onClick={() => startEditingSection(sectionIndex)}
            style={{
              ...getButtonStyle('secondary'),
              padding: '8px 18px',
              fontSize: '14px',
              minWidth: '80px',
              marginTop: '1.2em',
              marginBottom: '0.6em'
            }}
            onMouseEnter={(e) => handleButtonHover(e, true)}
            onMouseLeave={(e) => handleButtonHover(e, false)}
            title={t('reports.editThisSection')}
          >
            {t('common.edit')}
          </button>
        )}
      </div>
    );
  };

  const renderCheckMetadata = (check) => {
    // 检查是否有图片文件
    const hasImage = check.file_url && check.file_mime_type &&
      (check.file_mime_type.startsWith('image/') ||
        ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'].includes(check.file_mime_type.toLowerCase()));

    // 检查是否有音频文件
    const hasAudio = check.file_url && check.file_mime_type &&
      (check.file_mime_type.startsWith('audio/') ||
        ['audio/aac', 'audio/mp3', 'audio/wav', 'audio/ogg', 'audio/m4a', 'audio/mpeg'].includes(check.file_mime_type.toLowerCase()));

    // 处理metadata
    let metadataItems = [];
    if (check.metadata && Array.isArray(check.metadata)) {
      metadataItems = check.metadata;
    } else if (check.metadata && typeof check.metadata === 'object') {
      metadataItems = Object.entries(check.metadata).map(([key, value]) => ({
        name: key,
        value: value
      }));
    }

    const hasMetadata = metadataItems.length > 0;

    // 如果既没有图片、音频也没有metadata，显示无数据
    if (!hasImage && !hasAudio && !hasMetadata) {
      return <p style={{ color: '#334255' }}>{t('reports.noMetadata')}</p>;
    }

    return (
      <div className="check-metadata">
        {/* 显示图片 */}
        {hasImage && (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ marginBottom: '10px', color: '#2c3e50' }}>{t('reports.checkImage')}</h4>
            <div style={{
              border: '2px solid #dde6e9',
              borderRadius: '8px',
              padding: '10px',
              backgroundColor: '#f8f9fa',
              textAlign: 'center'
            }}>
              <img
                src={check.file_url}
                alt={`${getCheckTypeName(check.check_type)} 检查图片`}
                style={{
                  maxWidth: '100%',
                  maxHeight: '400px',
                  borderRadius: '4px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div style={{ display: 'none', color: '#556476', marginTop: '10px' }}>
                {t('reports.imageLoadError')}
              </div>
              <div style={{ marginTop: '8px', fontSize: '0.9em', color: '#556476' }}>
                {t('reports.fileType')}: {check.file_mime_type}
              </div>
            </div>
          </div>
        )}

        {/* 显示音频 */}
        {hasAudio && (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ marginBottom: '10px', color: '#2c3e50' }}>{t('reports.checkAudio')}</h4>
            <div style={{
              border: '2px solid #dde6e9',
              borderRadius: '8px',
              padding: '15px',
              backgroundColor: '#f8f9fa'
            }}>
              <audio
                controls
                style={{
                  width: '100%',
                  marginBottom: '10px'
                }}
                preload="metadata"
              >
                <source src={check.file_url} type={check.file_mime_type} />
                {t('reports.audioNotSupported')}
              </audio>
              <div style={{ fontSize: '0.9em', color: '#556476' }}>
                {t('reports.fileType')}: {check.file_mime_type}
              </div>
              <div style={{ fontSize: '0.9em', color: '#556476', marginTop: '5px' }}>
                <a
                  href={check.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#1d6a86',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                >
                  {t('reports.downloadAudio')}
                </a>
              </div>
            </div>
          </div>
        )}

        {/* 显示metadata */}
        {hasMetadata && (
          <div>
            <h4 style={{ color: '#14253a' }}>{t('reports.checkItemData')}</h4>
            <table className="paper-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{
                    textAlign: 'left',
                    padding: '8px',
                    backgroundColor: '#eef7fa',
                    border: '1px solid #dde6e9',
                    fontWeight: '600'
                  }}>
                    {t('reports.name')}
                  </th>
                  <th style={{
                    textAlign: 'left',
                    padding: '8px',
                    backgroundColor: '#eef7fa',
                    border: '1px solid #dde6e9',
                    fontWeight: '600'
                  }}>
                    {t('reports.value')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {metadataItems.map((item, idx) => (
                  <tr key={idx}>
                    <td style={{
                      padding: '8px',
                      border: '1px solid #dde6e9'
                    }}>
                      {item.name_local || item.name}
                    </td>
                    <td style={{
                      padding: '8px',
                      border: '1px solid #dde6e9'
                    }}>
                      {item.value !== undefined && item.value !== null
                        ? <span>
                          {String(item.value)}
                          {item.unit ? ` ${item.unit}` : ''}
                          {item.reference_range ? ` (${t('reports.referenceRange')}: ${item.reference_range})` : ''}
                        </span>
                        : t('reports.noData')
                      }
                      {item.description_local || item.description
                        ? <div style={{ marginTop: '5px', color: '#556476', fontSize: '0.9em' }}>
                          {item.description_local || item.description}
                        </div>
                        : null
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // 获取结束标题
  const getEndTitle = (text) => {
    const endMappings = {
      '问诊结束': t('reports.consultationFinish')
    };

    if (endMappings[text]) {
      return endMappings[text];
    }
  };

  // 格式化报告类型显示
  const formatReportType = (reportType) => {
    if (!reportType) return '';
    
    const typeMap = {
      'proposal': t('reports.proposalReport'),
      'final': t('reports.finalReport')
    };
    
    return typeMap[reportType] || reportType;
  };

  const formatVisitType = (visitType) => {
    if (visitType === 'follow_up') {
      return isZh ? '复诊' : 'Follow-up';
    }
    if (visitType === 'initial') {
      return isZh ? '初诊' : 'Initial';
    }
    if (visitType === 'checkup') {
      return isZh ? '体检' : 'Checkup';
    }
    return isZh ? '未标记' : 'Unspecified';
  };

  const formatRelatedVisits = (relatedVisitIds) => {
    if (!relatedVisitIds || relatedVisitIds.length === 0) {
      return isZh ? '无关联来源 Visit' : 'No linked source visits';
    }

    return relatedVisitIds.map((visitId) => `#${visitId}`).join(' / ');
  };

  const formatClinicLabel = (name, clinicId) => {
    if (name) {
      return name;
    }
    if (clinicId) {
      return `Clinic #${clinicId}`;
    }
    return isZh ? '未注明诊所' : 'Unknown clinic';
  };

  const buildRelatedVisitLink = (visitId) => `/reviewed-reports?visit_id=${visitId}`;
  const buildAppointmentQueueLink = (orderId) => `/appointment-orders?order_id=${orderId}`;

  // 检查项目中英文映射字典
  const getExamTitle = (text) => {
    const examMappings = {
      '快速链球菌检测': t('reports.rapidStrepTest'),
      '全血细胞计数+分类计数': t('reports.completeBloodCountDiff'),
      '肺炎支原体抗体检测': t('reports.mycoplasmaPneumoniaeTest'),
      '血常规+C反应蛋白': t('reports.bloodCountCReactiveProtein'),
      '流感病毒抗原检测': t('reports.influenzaVirusAntigenTest'),
      '新冠病毒抗原检测': t('reports.covidAntigenTest'),
      '六项呼吸道病原体核酸检测': t('reports.respiratoryPathogenNucleicAcid'),
      '尿液分析': t('reports.urineAnalysis'),
      '粪常规': t('reports.fecalRoutine'),
      '腹部触诊': t('reports.abdominalPalpation'),
      '体温测量': t('reports.temperatureMeasurement'),
      '血压测量': t('reports.bloodPressureMeasurement'),
      '心肺听诊': t('reports.cardiopulmonaryAuscultation'),
      '咽部检查': t('reports.throatExamination')
    };

    // 如果有完全匹配，返回翻译
    if (examMappings[text]) {
      return examMappings[text];
    }

    // 如果没有完全匹配，尝试关键词匹配
    const keywordDict = {
      '快速链球菌检测': ['快速', '链球菌'],
      '全血细胞计数+分类计数': ['全血', '细胞', '计数', '分类'],
      '肺炎支原体抗体检测': ['肺炎', '支原体', '抗体'],
      '血常规+C反应蛋白': ['血常规', 'C反应蛋白'],
      '流感病毒抗原检测': ['流感'],
      '新冠病毒抗原检测': ['新冠'],
      '六项呼吸道病原体核酸检测': ['呼吸道', '病原体', '核酸'],
      '尿液分析': ['尿液', '分析'],
      '粪常规': ['粪'],
      '腹部触诊': ['腹'],
      '体温测量': ['体', '温'],
      '血压测量': ['血', '压'],
      '心肺听诊': ['心', '肺', '听'],
      '咽部检查': ['咽', '喉'],
    };

    const matchedExam = Object.entries(keywordDict).find(([key, keywords]) =>
      keywords.some(keyword => text.includes(keyword))
    );

    if (matchedExam && examMappings[matchedExam[0]]) {
      return examMappings[matchedExam[0]];
    }

    // 如果都没有匹配，返回原文
    return text;
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'transparent',
        padding: '20px',
        position: 'relative'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '50px',
          maxWidth: '1200px',
          margin: '0 auto',
          paddingTop: '100px'
        }}>
          <div className="loading-spinner" style={{
            display: 'inline-block',
            width: '40px',
            height: '40px',
            border: '4px solid rgba(0,0,0,.1)',
            borderRadius: '50%',
            borderTopColor: '#667eea',
            animation: 'spin 1s linear infinite',
            marginBottom: '20px'
          }}></div>
          <p style={{ fontSize: '1.2rem', color: '#666' }}>{t('common.loading')}</p>

          <style>{`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'transparent',
      padding: '0px',
      position: 'relative'
    }}>
      {/* Back按钮区域 - 左上角 */}
      <div style={{
        position: 'absolute',
        top: '0px',
        left: '0px',
        zIndex: 1000
      }}>
        <button
          onClick={() => navigate('/reports')}
          style={getButtonStyle('dark')}
          onMouseEnter={(e) => handleButtonHover(e, true)}
          onMouseLeave={(e) => handleButtonHover(e, false)}
        >
          {t('common.back')}
        </button>
      </div>

      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
        paddingTop: '60px'
      }}>
        {/* 标题栏 */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px',
          background: 'rgba(250, 245, 236, 0.94)',
          padding: '20px',
          borderRadius: '16px',
          boxShadow: '0 18px 48px rgba(0, 0, 0, 0.16)',
          backdropFilter: 'blur(18px)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <h2 style={{
              margin: 0,
              fontSize: '2rem',
              fontWeight: '700',
              background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              {t('reports.reviewTitle')} #{id}
            </h2>
            {report && report.report_type && (
              <span style={{
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '600',
                background: report.report_type === 'proposal' 
                  ? 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)'
                  : 'linear-gradient(135deg, rgba(46, 204, 113, 0.1) 0%, rgba(39, 174, 96, 0.1) 100%)',
                color: report.report_type === 'proposal' ? '#667eea' : '#27ae60',
                border: report.report_type === 'proposal' 
                  ? '1px solid rgba(102, 126, 234, 0.3)' 
                  : '1px solid rgba(46, 204, 113, 0.3)',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                {formatReportType(report.report_type)}
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => {
                setLoading(true);
                setError('');
                setChecksReady(false); // 重置检查项准备状态
                const fetchReport = async () => {
                  try {
                    const data = await getReportById(id);
                    setReport(data);

                    console.log('refreshed report data', data);

                    // 判断content是否存在
                    let hasContent = false;

                    // 如果病历内容是字符串，直接使用
                    if (typeof data.content === 'string' && data.content.trim() !== '') {
                      setReportContent(data.content);
                      hasContent = true;
                    } else if (data.content && typeof data.content === 'object' && Object.keys(data.content).length > 0) {
                      // 如果病历内容是非空对象，转换为JSON字符串
                      setReportContent(JSON.stringify(data.content, null, 2));
                      hasContent = true;
                    } else {
                      // 如果病历内容为空，设置为空字符串
                      setReportContent('');
                      hasContent = false;
                    }

                    // 获取相关的检查项
                    if (data.visit_id) {
                      await fetchChecks(data.visit_id);
                      
                      // 获取待检查项目 - 添加 await 确保数据加载完成
                      await fetchPendingChecks(data.visit_id);
                      await fetchAppointmentOrders(data.visit_id);
                    } else {
                      setChecksReady(true); // 如果没有visit_id，直接设为ready
                    }

                    setLoading(false);
                  } catch (error) {
                    console.error('获取报告详情失败:', error);
                    setError(t('reports.fetchReportError') + ': ' + (error.response?.data?.error || t('common.unknownError')));
                    setChecksReady(true); // 即使出错也设为ready，避免按钮永远不显示
                    setLoading(false);
                  }
                };
                fetchReport();
              }}
              style={getButtonStyle('success')}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
            >
              {t('common.refresh')}
            </button>
          </div>
        </div>

        {error && (
          <div style={{
            color: '#ff416c',
            marginBottom: '20px',
            textAlign: 'center',
            background: 'rgba(255, 65, 108, 0.1)',
            padding: '15px',
            borderRadius: '8px',
            border: '1px solid rgba(255, 65, 108, 0.3)',
            fontWeight: '500'
          }}>
            {error}
          </div>
        )}

        {successMessage && (
          <div style={{
            color: '#27ae60',
            marginBottom: '20px',
            textAlign: 'center',
            background: 'rgba(46, 204, 113, 0.1)',
            padding: '15px',
            borderRadius: '8px',
            border: '1px solid rgba(46, 204, 113, 0.3)',
            fontWeight: '500'
          }}>
            {successMessage}
          </div>
        )}

        <div style={{
          marginBottom: '20px',
          padding: '20px',
          background: 'rgba(250, 245, 236, 0.94)',
          borderRadius: '16px',
          boxShadow: '0 18px 48px rgba(0, 0, 0, 0.16)',
          backdropFilter: 'blur(18px)'
        }}>
          <h3 style={{
            margin: '0 0 20px 0',
            fontSize: '1.5rem',
            fontWeight: '600',
            background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            {t('reports.reportInfo')}
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <p style={{ margin: '8px 0', textAlign: 'left', paddingLeft: '15px' }}>
              <strong style={{ color: '#2c3e50' }}>{t('reports.reportId')}:</strong>
              <span style={{ marginLeft: '8px', color: '#34495e' }}>{report.id}</span>
            </p>
            <p style={{ margin: '8px 0', textAlign: 'left', paddingLeft: '15px' }}>
              <strong style={{ color: '#2c3e50' }}>{t('reports.status')}:</strong>
              <span style={{
                marginLeft: '8px',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: '600',
                ...(report.status === 'pending' ? {
                  background: 'rgba(241, 196, 15, 0.1)',
                  color: '#f39c12',
                  border: '1px solid rgba(241, 196, 15, 0.3)'
                } : report.status === 'approved' ? {
                  background: 'rgba(46, 204, 113, 0.1)',
                  color: '#27ae60',
                  border: '1px solid rgba(46, 204, 113, 0.3)'
                } : {
                  background: 'rgba(231, 76, 60, 0.1)',
                  color: '#e74c3c',
                  border: '1px solid rgba(231, 76, 60, 0.3)'
                })
              }}>
                {t(`reports.${report.status}`)}
              </span>
            </p>
            <p style={{ margin: '8px 0', textAlign: 'left', paddingLeft: '15px' }}>
              <strong style={{ color: '#2c3e50' }}>{t('reports.clinicId')}:</strong>
              <span style={{ marginLeft: '8px', color: '#34495e' }}>{report.clinic_id || t('reports.notSpecified')}</span>
            </p>
            <p style={{ margin: '8px 0', textAlign: 'left', paddingLeft: '15px' }}>
              <strong style={{ color: '#2c3e50' }}>{t('reports.clinicName')}:</strong>
              <span style={{ marginLeft: '8px', color: '#34495e' }}>{report.clinic_name || t('reports.notSpecified')}</span>
            </p>
            <p style={{ margin: '8px 0', textAlign: 'left', paddingLeft: '15px' }}>
              <strong style={{ color: '#2c3e50' }}>{t('reports.visitId')}:</strong>
              <span style={{ marginLeft: '8px', color: '#34495e' }}>{report.visit_id}</span>
            </p>
            <p style={{ margin: '8px 0', textAlign: 'left', paddingLeft: '15px' }}>
              <strong style={{ color: '#2c3e50' }}>{isZh ? '就诊类型' : 'Visit type'}:</strong>
              <span style={{ marginLeft: '8px', color: '#34495e' }}>{formatVisitType(report.visit_type)}</span>
            </p>
            <p style={{ margin: '8px 0', textAlign: 'left', paddingLeft: '15px' }}>
              <strong style={{ color: '#2c3e50' }}>{t('reports.createdAt')}:</strong>
              <span style={{ marginLeft: '8px', color: '#34495e' }}>{formatDate(report.created_at)}</span>
            </p>
            <p style={{ margin: '8px 0', textAlign: 'left', paddingLeft: '15px' }}>
              <strong style={{ color: '#2c3e50' }}>{isZh ? '关联来源' : 'Related visits'}:</strong>
              <span style={{ marginLeft: '8px', color: '#34495e' }}>{formatRelatedVisits(report.related_visit_ids)}</span>
            </p>
            {report.related_visit_ids?.length > 0 && (
              <div className="visit-chip-list" style={{ paddingLeft: '15px', marginTop: '2px' }}>
                {report.related_visit_ids.map((visitId) => (
                  <Link key={`report-review-related-${visitId}`} to={buildRelatedVisitLink(visitId)} className="visit-chip">
                    #{visitId}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {appointmentOrders.length > 0 && (
            <div style={{ marginTop: '24px', paddingTop: '20px', borderTop: '1px solid rgba(0, 0, 0, 0.08)' }}>
              <strong style={{ color: '#2c3e50', display: 'block', marginBottom: '12px' }}>
                {isZh ? '关联预约单' : 'Linked appointment orders'}
              </strong>
              <div className="mini-card-grid">
                {appointmentOrders.map((order) => (
                  <div
                    key={order.id}
                    className="mini-card"
                    style={{ background: 'rgba(255, 255, 255, 0.55)', borderColor: 'rgba(0, 0, 0, 0.08)' }}
                  >
                    <div className="mini-card__header">
                      <span className="mini-card__title" style={{ color: '#14253a' }}>
                        {order.description || order.check_type}
                      </span>
                      <span style={{ color: '#667085', fontSize: '13px' }}>#{order.id}</span>
                    </div>
                    <div className="mini-card__meta" style={{ color: '#556476' }}>
                      {isZh ? '来源诊所' : 'Source clinic'}: {formatClinicLabel(order.source_clinic_name, order.source_clinic_id)}
                    </div>
                    <div className="mini-card__meta" style={{ color: '#556476' }}>
                      {isZh ? '接诊诊所' : 'Claim clinic'}: {formatClinicLabel(order.claim_clinic_name, order.claim_clinic_id)}
                    </div>
                    <div className="inline-link-row" style={{ marginTop: '0.15rem' }}>
                      <Link className="inline-link" to={buildAppointmentQueueLink(order.id)}>
                        {isZh ? '在预约队列中查看' : 'Open in queue'}
                      </Link>
                      <Link className="inline-link" to={buildRelatedVisitLink(order.source_visit_id)}>
                        {isZh ? '查看来源 Visit' : 'Open source visit'}
                      </Link>
                      {order.source_report_id && (
                        <Link className="inline-link" to={`/reports/${order.source_report_id}/view`}>
                          {isZh ? '查看来源报告' : 'Open source report'}
                        </Link>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div style={{
          marginBottom: '20px',
          background: 'rgba(250, 245, 236, 0.94)',
          borderRadius: '16px',
          padding: '30px',
          boxShadow: '0 18px 48px rgba(0, 0, 0, 0.16)',
          backdropFilter: 'blur(18px)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3 style={{
              margin: 0,
              fontSize: '1.5rem',
              fontWeight: '600',
              background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              {t('reports.reportContent')}
            </h3>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                type="button"
                onClick={handleExportMarkdown}
                disabled={!reportContent || reportContent.trim() === ''}
                style={{
                  ...getButtonStyle('secondary'),
                  opacity: (!reportContent || reportContent.trim() === '') ? 0.4 : 1,
                  cursor: (!reportContent || reportContent.trim() === '') ? 'not-allowed' : 'pointer'
                }}
                onMouseEnter={(e) => (reportContent && reportContent.trim() !== '') && handleButtonHover(e, true)}
                onMouseLeave={(e) => (reportContent && reportContent.trim() !== '') && handleButtonHover(e, false)}
                title="导出为Markdown格式"
              >
                📥 MD
              </button>

              <button
                type="button"
                onClick={handleExportPDF}
                disabled={!reportContent || reportContent.trim() === ''}
                style={{
                  ...getButtonStyle('primary'),
                  opacity: (!reportContent || reportContent.trim() === '') ? 0.4 : 1,
                  cursor: (!reportContent || reportContent.trim() === '') ? 'not-allowed' : 'pointer'
                }}
                onMouseEnter={(e) => (reportContent && reportContent.trim() !== '') && handleButtonHover(e, true)}
                onMouseLeave={(e) => (reportContent && reportContent.trim() !== '') && handleButtonHover(e, false)}
                title="导出为PDF格式"
              >
                📄 PDF
              </button>

              <button
                type="button"
                onClick={handleExportDOCX}
                disabled={!reportContent || reportContent.trim() === ''}
                style={{
                  ...getButtonStyle('success'),
                  opacity: (!reportContent || reportContent.trim() === '') ? 0.4 : 1,
                  cursor: (!reportContent || reportContent.trim() === '') ? 'not-allowed' : 'pointer'
                }}
                onMouseEnter={(e) => (reportContent && reportContent.trim() !== '') && handleButtonHover(e, true)}
                onMouseLeave={(e) => (reportContent && reportContent.trim() !== '') && handleButtonHover(e, false)}
                title="导出为Word格式"
              >
                📝 Word
              </button>
              
              <button
                type="button"
                onClick={toggleViewMode}
                style={getButtonStyle('dark')}
                onMouseEnter={(e) => handleButtonHover(e, true)}
                onMouseLeave={(e) => handleButtonHover(e, false)}
              >
                {viewMode === 'edit' ? t('reports.backToPreview') : t('reports.editContent')}
              </button>

              {(!reportContent || reportContent.trim() === '') && !generating && checksReady && (
                <button
                  type="button"
                  onClick={handleGenerateReport}
                  style={getButtonStyle('primary')}
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  {t('reports.generateReport')}
                </button>
              )}

              {(!reportContent || reportContent.trim() === '') && !generating && !checksReady && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#667eea',
                  fontWeight: '500'
                }}>
                  <span>{t('reports.loadingChecks')}</span>
                  <div className="loading-spinner" style={{
                    display: 'inline-block',
                    width: '20px',
                    height: '20px',
                    border: '3px solid rgba(0,0,0,.1)',
                    borderRadius: '50%',
                    borderTopColor: '#667eea',
                    animation: 'spin 1s linear infinite',
                    marginLeft: '10px'
                  }}></div>
                </div>
              )}

              {generating && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#667eea',
                  fontWeight: '500'
                }}>
                  <span>{t('reports.generating')}</span>
                  <div className="loading-spinner" style={{
                    display: 'inline-block',
                    width: '20px',
                    height: '20px',
                    border: '3px solid rgba(0,0,0,.1)',
                    borderRadius: '50%',
                    borderTopColor: '#667eea',
                    animation: 'spin 1s linear infinite',
                    marginLeft: '10px'
                  }}></div>
                </div>
              )}
            </div>
          </div>

          {viewMode === 'edit' ? (
            <textarea
              value={reportContent}
              onChange={(e) => setReportContent(e.target.value)}
              style={{
                width: '100%',
                minHeight: '400px',
                fontFamily: 'monospace',
                padding: '15px',
                border: '2px solid rgba(102, 126, 234, 0.2)',
                borderRadius: '8px',
                fontSize: '14px',
                lineHeight: '1.6',
                background: 'rgba(255, 248, 241, 0.88)',
                color: '#1a202c',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                resize: 'vertical'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = 'rgba(102, 126, 234, 0.5)';
                e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(102, 126, 234, 0.2)';
                e.target.style.boxShadow = 'none';
              }}
            />
          ) : (
            <div style={{
              width: '100%',
              minHeight: '300px',
              border: '1px solid rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              padding: '20px',
              backgroundColor: '#f9f9f9',
              overflowX: 'auto',
              boxSizing: 'border-box'
            }}>
              {reportContent ? (
                <div className="markdown-content markdown-content--paper" style={{ textAlign: 'left' }}>
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                      a: ({ node, href, children, ...props }) => {
                        const { ordered, ...validProps } = props;
                        return <a {...validProps} href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
                      },
                      pre: ({ node, children, ...props }) => {
                        const { ordered, ...validProps } = props;
                        return <pre {...validProps} style={{ margin: '1em 0' }}>{children}</pre>;
                      },
                      h1: ({ node, children, ...props }) => {
                        const { ordered, ...validProps } = props;
                        return <h1 {...validProps} style={{ textAlign: 'left', color: '#2c3e50', fontWeight: '700', fontSize: '1.8em', marginTop: '1.5em', marginBottom: '0.8em', paddingBottom: '0.3em', borderBottom: '1px solid #eaecef' }}>{children}</h1>;
                      },
                      h2: CustomH2,
                      h3: ({ node, children, ...props }) => {
                        const { ordered, ...validProps } = props;
                        return <h3 {...validProps} style={{ textAlign: 'left', color: '#2980b9', fontWeight: '500', fontSize: '1.3em', marginTop: '1em', marginBottom: '0.5em' }}>{children}</h3>;
                      },
                      p: ({ node, children, ...props }) => {
                        const { ordered, ...validProps } = props;
                        return <p {...validProps} style={{ textAlign: 'left', marginTop: '0.5em', marginBottom: '1em', lineHeight: '1.6' }}>{children}</p>;
                      },
                      ul: ({ node, children, ...props }) => {
                        const { ordered, ...validProps } = props;
                        return <ul {...validProps} style={{ textAlign: 'left', marginTop: '0.5em', marginBottom: '1em', paddingLeft: '2em' }}>{children}</ul>;
                      },
                      ol: ({ node, children, ...props }) => {
                        const { ordered, ...validProps } = props;
                        return <ol {...validProps} style={{ textAlign: 'left', marginTop: '0.5em', marginBottom: '1em', paddingLeft: '2em' }}>{children}</ol>;
                      },
                      li: ({ node, children, ...props }) => {
                        const { ordered, ...validProps } = props;
                        return <li {...validProps} style={{ textAlign: 'left', marginBottom: '0.3em' }}>{children}</li>;
                      }
                    }}
                  >
                    {reportContent}
                  </ReactMarkdown>
                </div>
              ) : (
                <p style={{ color: '#666', textAlign: 'center', fontSize: '1.1rem' }}>{t('reports.noContent')}</p>
              )}
            </div>
          )}
        </div>

        {/* 检查项列表 */}
        <div style={{
          marginBottom: '20px',
          background: 'rgba(250, 245, 236, 0.94)',
          borderRadius: '16px',
          padding: '30px',
          boxShadow: '0 18px 48px rgba(0, 0, 0, 0.16)',
          backdropFilter: 'blur(18px)'
        }}>
          <h3 style={{
            margin: '0 0 20px 0',
            fontSize: '1.5rem',
            fontWeight: '600',
            background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            {t('reports.checksList')}
          </h3>
          <div className="checks-container">
            {checksLoading ? (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <div className="loading-spinner" style={{
                  display: 'inline-block',
                  width: '40px',
                  height: '40px',
                  border: '4px solid rgba(0,0,0,.1)',
                  borderRadius: '50%',
                  borderTopColor: '#667eea',
                  animation: 'spin 1s linear infinite',
                  marginBottom: '20px'
                }}></div>
                <p style={{ fontSize: '1.1rem', color: '#666' }}>{t('reports.loadingChecks')}</p>
              </div>
            ) : checksError ? (
              <div style={{
                color: '#ff416c',
                marginBottom: '20px',
                textAlign: 'center',
                background: 'rgba(255, 65, 108, 0.1)',
                padding: '15px',
                borderRadius: '8px',
                border: '1px solid rgba(255, 65, 108, 0.3)',
                fontWeight: '500'
              }}>
                {checksError}
              </div>
            ) : checks.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#666', fontSize: '1.1rem', padding: '50px' }}>
                {t('reports.noChecksData')}
              </p>
            ) : (
              <div className="checks-list">
                <div style={{ overflowX: 'auto' }}>
                  <table className="paper-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{
                        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)'
                      }}>
                        <th style={{ padding: '15px', textAlign: 'left', border: '1px solid rgba(0, 0, 0, 0.1)', fontWeight: '600', width: '30%', color: '#14253a' }}>
                          {t('reports.checkType')}
                        </th>
                        <th style={{ padding: '15px', textAlign: 'left', border: '1px solid rgba(0, 0, 0, 0.1)', fontWeight: '600', width: '25%', color: '#14253a' }}>
                          {t('reports.createdAt')}
                        </th>
                        <th style={{ padding: '15px', textAlign: 'left', border: '1px solid rgba(0, 0, 0, 0.1)', fontWeight: '600', width: '45%', color: '#14253a' }}>
                          {t('reports.actions')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {checks.map((check, index) => (
                        <React.Fragment key={check.id || index}>
                          <tr className="check-row" style={{
                            transition: 'background-color 0.3s ease',
                            '&:hover': { backgroundColor: 'rgba(102, 126, 234, 0.05)' }
                          }}>
                            <td style={{ padding: '15px', border: '1px solid rgba(0, 0, 0, 0.1)', color: '#334255' }}>
                              <span style={{
                                padding: '6px 12px',
                                borderRadius: '6px',
                                fontSize: '12px',
                                fontWeight: '600',
                                textTransform: 'uppercase',
                                background: 'linear-gradient(135deg, rgba(52, 152, 219, 0.1) 0%, rgba(41, 128, 185, 0.1) 100%)',
                                color: '#2980b9',
                                border: '1px solid rgba(52, 152, 219, 0.3)'
                              }}>
                                {getCheckTypeName(check.check_type)}
                              </span>
                            </td>
                            <td style={{ padding: '15px', border: '1px solid rgba(0, 0, 0, 0.1)', color: '#334255' }}>
                              {formatDate(check.created_at)}
                            </td>
                            <td style={{ padding: '15px', border: '1px solid rgba(0, 0, 0, 0.1)', color: '#334255' }}>
                              <button
                                className="check-toggle-btn"
                                onClick={() => toggleCheckDetails(index)}
                                style={{
                                  ...getButtonStyle('secondary'),
                                  padding: '8px 16px',
                                  fontSize: '14px',
                                  minWidth: 'auto'
                                }}
                                onMouseEnter={(e) => handleButtonHover(e, true)}
                                onMouseLeave={(e) => handleButtonHover(e, false)}
                              >
                                {t('reports.viewDetails')}
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="3" style={{ padding: '0' }}>
                              <div
                                id={`check-details-${index}`}
                                className="check-details"
                                style={{
                                  display: 'none',
                                  padding: '20px',
                                  background: 'rgba(102, 126, 234, 0.02)',
                                  borderTop: '1px solid rgba(102, 126, 234, 0.1)'
                                }}
                              >
                                {renderCheckMetadata(check)}
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 待检查项目列表 - 所有报告类型都显示 */}
        {report && (
          <div style={{
            marginBottom: '20px',
            background: 'rgba(250, 245, 236, 0.94)',
            borderRadius: '16px',
            padding: '30px',
            boxShadow: '0 18px 48px rgba(0, 0, 0, 0.16)',
            backdropFilter: 'blur(18px)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.5rem',
                fontWeight: '600',
                background: 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                {t('reports.pendingChecksList')}
              </h3>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                {/* 创建待检查项目按钮 - 仅在proposal类型且pending状态时可用 */}
                {canAddPendingCheck() ? (
                  <button
                    onClick={() => setShowCreatePendingCheck(true)}
                    style={{
                      ...getButtonStyle('primary'),
                      padding: '8px 16px',
                      fontSize: '14px',
                      minWidth: 'auto'
                    }}
                    onMouseEnter={(e) => handleButtonHover(e, true)}
                    onMouseLeave={(e) => handleButtonHover(e, false)}
                  >
                    {t('reports.addPendingCheck')}
                  </button>
                ) : (
                  <div style={{
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#556476',
                    background: 'rgba(20, 37, 58, 0.05)',
                    borderRadius: '8px',
                    border: '1px solid rgba(20, 37, 58, 0.12)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <path d="M15 9l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>
                      {report && report.report_type !== 'proposal' 
                        ? t('reports.addPendingCheckDisabledType')
                        : t('reports.addPendingCheckDisabledStatus')
                      }
                    </span>
                  </div>
                )}
                
                {/* 审核状态提示 */}
                {pendingChecks.length > 0 && (
                  <div style={{
                    padding: '8px 16px',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    ...(hasPendingChecks() ? {
                      background: 'rgba(241, 196, 15, 0.1)',
                      color: '#f39c12',
                      border: '1px solid rgba(241, 196, 15, 0.3)'
                    } : {
                      background: 'rgba(46, 204, 113, 0.1)',
                      color: '#27ae60',
                      border: '1px solid rgba(46, 204, 113, 0.3)'
                    })
                  }}>
                    {hasPendingChecks() ? (
                      <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                          <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {t('reports.pendingReviewStatus', { 
                          pending: pendingChecks.filter(check => check.status === 'pending').length,
                          total: pendingChecks.length
                        })}
                      </>
                    ) : (
                      <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                        </svg>
                        {t('reports.allChecksReviewed')}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="checks-container">
              {pendingChecksLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                  <div className="loading-spinner" style={{
                    display: 'inline-block',
                    width: '40px',
                    height: '40px',
                    border: '4px solid rgba(0,0,0,.1)',
                    borderRadius: '50%',
                    borderTopColor: '#f39c12',
                    animation: 'spin 1s linear infinite',
                    marginBottom: '20px'
                  }}></div>
                  <p style={{ fontSize: '1.1rem', color: '#666' }}>{t('reports.loadingPendingChecks')}</p>
                </div>
              ) : pendingChecksError ? (
                <div style={{
                  color: '#ff416c',
                  marginBottom: '20px',
                  textAlign: 'center',
                  background: 'rgba(255, 65, 108, 0.1)',
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid rgba(255, 65, 108, 0.3)',
                  fontWeight: '500'
                }}>
                  {pendingChecksError}
                </div>
              ) : pendingChecks.length === 0 ? (
                <p style={{ textAlign: 'center', color: '#666', fontSize: '1.1rem', padding: '50px' }}>
                  {t('reports.noPendingChecksData')}
                </p>
              ) : (
                <div className="pending-checks-list">
                  <div style={{ overflowX: 'auto' }}>
                    <table className="paper-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{
                          background: 'linear-gradient(135deg, rgba(243, 156, 18, 0.1) 0%, rgba(230, 126, 34, 0.1) 100%)'
                        }}>
                          <th style={{ padding: '15px', textAlign: 'left', border: '1px solid rgba(0, 0, 0, 0.1)', fontWeight: '600', width: '20%', color: '#14253a' }}>
                            {t('reports.checkType')}
                          </th>
                          <th style={{ padding: '15px', textAlign: 'left', border: '1px solid rgba(0, 0, 0, 0.1)', fontWeight: '600', width: '15%', color: '#14253a' }}>
                            {t('reports.status')}
                          </th>
                          <th style={{ padding: '15px', textAlign: 'left', border: '1px solid rgba(0, 0, 0, 0.1)', fontWeight: '600', width: '15%', color: '#14253a' }}>
                            {t('reports.createdAt')}
                          </th>
                          <th style={{ padding: '15px', textAlign: 'left', border: '1px solid rgba(0, 0, 0, 0.1)', fontWeight: '600', width: '20%', color: '#14253a' }}>
                            {t('reports.description')}
                          </th>
                          <th style={{ padding: '15px', textAlign: 'left', border: '1px solid rgba(0, 0, 0, 0.1)', fontWeight: '600', width: '30%', color: '#14253a' }}>
                            {t('reports.actions')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingChecks.map((pendingCheck, index) => (
                          <tr key={pendingCheck.id || index} style={{
                            transition: 'background-color 0.3s ease',
                            '&:hover': { backgroundColor: 'rgba(243, 156, 18, 0.05)' }
                          }}>
                            <td style={{ padding: '15px', border: '1px solid rgba(0, 0, 0, 0.1)', color: '#334255' }}>
                              <span style={{
                                padding: '6px 12px',
                                borderRadius: '6px',
                                fontSize: '12px',
                                fontWeight: '600',
                                textTransform: 'uppercase',
                                background: 'linear-gradient(135deg, rgba(243, 156, 18, 0.1) 0%, rgba(230, 126, 34, 0.1) 100%)',
                                color: '#e67e22',
                                border: '1px solid rgba(243, 156, 18, 0.3)'
                              }}>
                                {getCheckTypeName(pendingCheck.check_type)}
                              </span>
                            </td>
                            <td style={{ padding: '15px', border: '1px solid rgba(0, 0, 0, 0.1)', color: '#334255' }}>
                              <span style={{
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                fontWeight: '600',
                                ...(pendingCheck.status === 'pending' ? {
                                  background: 'rgba(241, 196, 15, 0.1)',
                                  color: '#f39c12',
                                  border: '1px solid rgba(241, 196, 15, 0.3)'
                                } : pendingCheck.status === 'approved' ? {
                                  background: 'rgba(46, 204, 113, 0.1)',
                                  color: '#27ae60',
                                  border: '1px solid rgba(46, 204, 113, 0.3)'
                                } : pendingCheck.status === 'completed' ? {
                                  background: 'rgba(52, 152, 219, 0.1)',
                                  color: '#3498db',
                                  border: '1px solid rgba(52, 152, 219, 0.3)'
                                } : {
                                  background: 'rgba(231, 76, 60, 0.1)',
                                  color: '#e74c3c',
                                  border: '1px solid rgba(231, 76, 60, 0.3)'
                                })
                              }}>
                                {t(`reports.pendingCheckStatus.${pendingCheck.status}`)}
                              </span>
                            </td>
                            <td style={{ padding: '15px', border: '1px solid rgba(0, 0, 0, 0.1)', color: '#334255' }}>
                              {formatDate(pendingCheck.created_at)}
                            </td>
                            <td style={{ padding: '15px', border: '1px solid rgba(0, 0, 0, 0.1)', color: '#334255' }}>
                              {pendingCheck.description || t('reports.noDescription')}
                            </td>
                            <td style={{ padding: '15px', border: '1px solid rgba(0, 0, 0, 0.1)', color: '#334255' }}>
                              {pendingCheck.status === 'pending' ? (
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                  {isUserCreatedCheck(pendingCheck) ? (
                                    // 用户创建的待检查项：显示"确定"和"删除"按钮
                                    <>
                                      <button
                                        onClick={() => handleReviewPendingCheck(pendingCheck.id, 'approved')}
                                        disabled={reviewSubmitting}
                                        style={{
                                          ...getButtonStyle('success'),
                                          padding: '6px 12px',
                                          fontSize: '12px',
                                          minWidth: '60px'
                                        }}
                                        onMouseEnter={(e) => handleButtonHover(e, true)}
                                        onMouseLeave={(e) => handleButtonHover(e, false)}
                                      >
                                        {t('reports.confirmUserCreated')}
                                      </button>
                                      <button
                                        onClick={() => handleDeletePendingCheck(pendingCheck.id)}
                                        disabled={reviewSubmitting}
                                        style={{
                                          ...getButtonStyle('primary'),
                                          background: 'linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)',
                                          boxShadow: '0 4px 15px rgba(255, 65, 108, 0.4)',
                                          padding: '6px 12px',
                                          fontSize: '12px',
                                          minWidth: '60px'
                                        }}
                                        onMouseEnter={(e) => handleButtonHover(e, true)}
                                        onMouseLeave={(e) => handleButtonHover(e, false)}
                                      >
                                        {t('reports.deleteCheck')}
                                      </button>
                                    </>
                                  ) : (
                                    // 自动创建的待检查项：显示"通过"和"拒绝"按钮
                                    <>
                                      <button
                                        onClick={() => handleReviewPendingCheck(pendingCheck.id, 'approved')}
                                        disabled={reviewSubmitting}
                                        style={{
                                          ...getButtonStyle('success'),
                                          padding: '6px 12px',
                                          fontSize: '12px',
                                          minWidth: '60px'
                                        }}
                                        onMouseEnter={(e) => handleButtonHover(e, true)}
                                        onMouseLeave={(e) => handleButtonHover(e, false)}
                                      >
                                        {t('reports.approve')}
                                      </button>
                                      <button
                                        onClick={() => handleReviewPendingCheck(pendingCheck.id, 'rejected')}
                                        disabled={reviewSubmitting}
                                        style={{
                                          ...getButtonStyle('primary'),
                                          background: 'linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)',
                                          boxShadow: '0 4px 15px rgba(255, 65, 108, 0.4)',
                                          padding: '6px 12px',
                                          fontSize: '12px',
                                          minWidth: '60px'
                                        }}
                                        onMouseEnter={(e) => handleButtonHover(e, true)}
                                        onMouseLeave={(e) => handleButtonHover(e, false)}
                                      >
                                        {t('reports.reject')}
                                      </button>
                                    </>
                                  )}
                                </div>
                              ) : (
                                <div style={{ color: '#556476', fontSize: '14px' }}>
                                  {isUserCreatedCheck(pendingCheck) ? (
                                    // 用户创建的待检查项审核后的显示
                                    <>
                                      {pendingCheck.reviewer_name && (
                                        <div>{t('reports.confirmedBy')}: {pendingCheck.reviewer_name}</div>
                                      )}
                                      {pendingCheck.reviewed_at && (
                                        <div style={{ fontSize: '12px', marginTop: '4px', color: '#627487' }}>
                                          {formatDate(pendingCheck.reviewed_at)}
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    // 自动创建的待检查项审核后的显示
                                    <>
                                      {pendingCheck.reviewer_name && (
                                        <div>{t('reports.reviewedBy')}: {pendingCheck.reviewer_name}</div>
                                      )}
                                      {pendingCheck.reviewed_at && (
                                        <div style={{ fontSize: '12px', marginTop: '4px', color: '#627487' }}>
                                          {formatDate(pendingCheck.reviewed_at)}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* 历史对话区域 */}
        <div style={{
          marginBottom: '20px',
          background: 'rgba(250, 245, 236, 0.94)',
          borderRadius: '16px',
          padding: '30px',
          boxShadow: '0 18px 48px rgba(0, 0, 0, 0.16)',
          backdropFilter: 'blur(18px)'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            <h3 style={{
              margin: 0,
              fontSize: '1.5rem',
              fontWeight: '600',
              background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              {t('reports.conversationHistory')}
            </h3>
            <button
              onClick={() => setShowConversations(!showConversations)}
              style={{
                ...getButtonStyle('secondary'),
                padding: '8px 16px',
                fontSize: '14px',
                minWidth: 'auto'
              }}
              onMouseEnter={(e) => handleButtonHover(e, true)}
              onMouseLeave={(e) => handleButtonHover(e, false)}
            >
              {showConversations ? t('reports.hideConversation') : t('reports.showConversation')}
            </button>
          </div>

          {showConversations && (
            <div>
              {conversationsLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                  <div className="loading-spinner" style={{
                    display: 'inline-block',
                    width: '40px',
                    height: '40px',
                    border: '4px solid rgba(0,0,0,.1)',
                    borderRadius: '50%',
                    borderTopColor: '#667eea',
                    animation: 'spin 1s linear infinite',
                    marginBottom: '20px'
                  }}></div>
                  <p style={{ fontSize: '1.1rem', color: '#666' }}>{t('reports.loadingConversation')}</p>
                </div>
              ) : conversationsError ? (
                <div style={{
                  color: '#ff416c',
                  marginBottom: '20px',
                  textAlign: 'center',
                  background: 'rgba(255, 65, 108, 0.1)',
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid rgba(255, 65, 108, 0.3)',
                  fontWeight: '500'
                }}>
                  {conversationsError}
                </div>
              ) : conversations.length === 0 ? (
                <p style={{ textAlign: 'center', color: '#666', fontSize: '1.1rem', padding: '50px' }}>
                  {t('reports.noConversationData')}
                </p>
              ) : (
                <div style={{
                  maxHeight: '600px',
                  overflowY: 'auto',
                  padding: '20px',
                  background: 'rgba(248, 249, 250, 0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0, 0, 0, 0.1)'
                }}>
                  {conversations.map((message, index) => renderConversationMessage(message, index))}
                </div>
              )}
            </div>
          )}
        </div>

        {/* 审核表单 */}
        <div style={{
          background: 'rgba(250, 245, 236, 0.94)',
          borderRadius: '16px',
          padding: '30px',
          boxShadow: '0 18px 48px rgba(0, 0, 0, 0.16)',
          backdropFilter: 'blur(18px)'
        }}>
          <h3 style={{
            margin: '0 0 20px 0',
            fontSize: '1.5rem',
            fontWeight: '600',
            background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            {t('reports.reviewForm')}
          </h3>

          {report?.report_type === 'final' && report?.status === 'pending' && (
            <div style={{
              marginBottom: '24px',
              padding: '20px',
              borderRadius: '14px',
              background: 'rgba(255, 255, 255, 0.56)',
              border: '1px solid rgba(0, 0, 0, 0.08)'
            }}>
              <div style={{ display: 'grid', gap: '0.55rem', marginBottom: '16px' }}>
                <strong style={{ color: '#2c3e50', fontSize: '1rem' }}>
                  {isZh ? '复诊预约单草稿' : 'Follow-up appointment order drafts'}
                </strong>
                <span style={{ color: '#556476', fontSize: '14px', lineHeight: 1.6 }}>
                  {isZh
                    ? '这些预约单只会在 final report 审核通过时真正创建。审核拒绝时不会落库。'
                    : 'These orders are created only when the final report is approved. If the review is rejected, no appointment order is saved.'}
                </span>
              </div>

              <div style={{ display: 'grid', gap: '12px' }}>
                {appointmentDrafts.map((draft, index) => (
                  <div
                    key={`appointment-draft-${index}`}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'minmax(10rem, 13rem) minmax(0, 1fr) auto',
                      gap: '12px',
                      alignItems: 'start'
                    }}
                  >
                    <select
                      value={draft.check_type}
                      onChange={(event) => updateAppointmentDraft(index, 'check_type', event.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid rgba(102, 126, 234, 0.2)',
                        borderRadius: '8px',
                        fontSize: '14px',
                        background: 'rgba(255, 248, 241, 0.88)',
                        color: '#1a202c',
                        boxSizing: 'border-box'
                      }}
                    >
                      <option value="">{isZh ? '选择检查类型' : 'Select check type'}</option>
                      <optgroup label={isZh ? '设备可测项目' : 'Device-measurable'}>
                        <option value="blood_pressure">{t('checkTypes.blood_pressure')}</option>
                        <option value="blood_glucose">{t('checkTypes.blood_glucose')}</option>
                        <option value="temperature">{t('checkTypes.temperature')}</option>
                        <option value="body_height_weight">{t('checkTypes.body_height_weight')}</option>
                        <option value="spo2">{t('checkTypes.spo2')}</option>
                        <option value="lipid_panel">{t('checkTypes.lipid_panel')}</option>
                        <option value="body_composition">{t('checkTypes.body_composition')}</option>
                        <option value="uric_acid">{t('checkTypes.uric_acid')}</option>
                        <option value="cholesterol">{t('checkTypes.cholesterol')}</option>
                        <option value="urine_glucose">{t('checkTypes.urine_glucose')}</option>
                      </optgroup>
                      <optgroup label={isZh ? '实验室 / 影像' : 'Lab / Imaging'}>
                        <option value="blood">{t('checkTypes.blood')}</option>
                        <option value="urine">{t('checkTypes.urine')}</option>
                        <option value="ecg">{t('checkTypes.ecg')}</option>
                        <option value="ct">{t('checkTypes.ct')}</option>
                        <option value="xray">{t('checkTypes.xray')}</option>
                        <option value="ultrasound">{t('checkTypes.ultrasound')}</option>
                        <option value="mri">{t('checkTypes.mri')}</option>
                        <option value="pathology">{t('checkTypes.pathology')}</option>
                        <option value="endoscopy">{t('checkTypes.endoscopy')}</option>
                        <option value="other">{t('checkTypes.other')}</option>
                      </optgroup>
                    </select>

                    <input
                      type="text"
                      value={draft.description}
                      onChange={(event) => updateAppointmentDraft(index, 'description', event.target.value)}
                      placeholder={isZh ? '预约说明，例如服药两周后复查血压' : 'e.g. Recheck blood pressure after 2 weeks of medication'}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid rgba(102, 126, 234, 0.2)',
                        borderRadius: '8px',
                        fontSize: '14px',
                        background: 'rgba(255, 248, 241, 0.88)',
                        color: '#1a202c',
                        boxSizing: 'border-box',
                        outline: 'none',
                      }}
                    />

                    <button
                      type="button"
                      onClick={() => removeAppointmentDraft(index)}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: '1px solid rgba(102, 126, 234, 0.3)',
                        background: 'transparent',
                        color: '#4a5568',
                        cursor: 'pointer',
                        fontSize: '14px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {isZh ? '移除' : 'Remove'}
                    </button>
                  </div>
                ))}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap', marginTop: '16px' }}>
                <span style={{ color: '#667085', fontSize: '13px' }}>
                  {isZh
                    ? '支持一次创建多条预约单，后续患者可以跨诊所认领复诊。'
                    : 'You can prepare multiple follow-up orders here. Patients may claim them across clinics later.'}
                </span>
                <button
                  type="button"
                  onClick={addAppointmentDraft}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '999px',
                    border: '1px solid rgba(67, 214, 197, 0.4)',
                    background: 'linear-gradient(135deg, rgba(67, 214, 197, 0.2), rgba(67, 214, 197, 0.08))',
                    color: '#1a4a42',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  {isZh ? '新增预约单' : 'Add appointment order'}
                </button>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: '500',
                color: hasPendingChecks() ? '#999' : '#333'
              }}>
                {t('reports.reviewNote')}:
              </label>
              
              {hasPendingChecks() ? (
                <div style={{
                  width: '100%',
                  minHeight: '120px',
                  padding: '12px',
                  border: '2px solid rgba(241, 196, 15, 0.3)',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: 'rgba(241, 196, 15, 0.1)',
                  color: '#856404',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxSizing: 'border-box',
                  textAlign: 'center',
                  flexDirection: 'column',
                  gap: '10px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                      <path d="M2 17l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                      <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                    </svg>
                    <strong>{t('reports.pendingChecksWarningTitle')}</strong>
                  </div>
                  <div>
                    {t('reports.pendingChecksWarningMessage')}
                  </div>
                  <div style={{ fontSize: '13px', opacity: 0.8 }}>
                    {t('reports.pendingChecksCount', { count: pendingChecks.filter(check => check.status === 'pending').length })}
                  </div>
                </div>
              ) : (
                <textarea
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  style={{
                    width: '100%',
                    minHeight: '120px',
                    padding: '12px',
                    border: '2px solid rgba(102, 126, 234, 0.2)',
                    borderRadius: '8px',
                    fontSize: '14px',
                    background: 'rgba(255, 248, 241, 0.88)',
                    color: '#1a202c',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box',
                    resize: 'vertical'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = 'rgba(102, 126, 234, 0.5)';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = 'rgba(102, 126, 234, 0.2)';
                    e.target.style.boxShadow = 'none';
                  }}
                  placeholder={t('reports.reviewNotePlaceholder')}
                />
              )}
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={() => handleReview('approve')}
                disabled={submitting || hasPendingChecks()}
                style={{
                  ...getButtonStyle('success'),
                  opacity: (submitting || hasPendingChecks()) ? 0.4 : 1,
                  cursor: (submitting || hasPendingChecks()) ? 'not-allowed' : 'pointer',
                  filter: hasPendingChecks() ? 'grayscale(50%)' : 'none'
                }}
                onMouseEnter={(e) => !(submitting || hasPendingChecks()) && handleButtonHover(e, true)}
                onMouseLeave={(e) => !(submitting || hasPendingChecks()) && handleButtonHover(e, false)}
                title={hasPendingChecks() ? t('reports.reviewDisabledTooltip') : ''}
              >
                {submitting ? t('reports.submitting') : t('reports.approve')}
              </button>
              <button
                type="button"
                onClick={() => handleReview('reject')}
                disabled={submitting || hasPendingChecks()}
                style={{
                  ...getButtonStyle('primary'),
                  background: 'linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)',
                  boxShadow: '0 4px 15px rgba(255, 65, 108, 0.4)',
                  opacity: (submitting || hasPendingChecks()) ? 0.4 : 1,
                  cursor: (submitting || hasPendingChecks()) ? 'not-allowed' : 'pointer',
                  filter: hasPendingChecks() ? 'grayscale(50%)' : 'none'
                }}
                onMouseEnter={(e) => !(submitting || hasPendingChecks()) && handleButtonHover(e, true)}
                onMouseLeave={(e) => !(submitting || hasPendingChecks()) && handleButtonHover(e, false)}
                title={hasPendingChecks() ? t('reports.reviewDisabledTooltip') : ''}
              >
                {submitting ? t('reports.submitting') : t('reports.reject')}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* 渲染段落编辑模式 */}
      {editingSection !== null && renderSectionEditMode()}

      {/* 创建待检查项目对话框 */}
      {showCreatePendingCheck && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '30px',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '80vh',
            overflow: 'auto',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.5rem',
                fontWeight: '600',
                background: 'linear-gradient(135deg, #cfac67 0%, #43d6c5 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                {t('reports.createPendingCheckTitle')}
              </h3>
              <button
                onClick={() => {
                  setShowCreatePendingCheck(false);
                  setCreatePendingCheckData({ check_type: '', description: '' });
                  setError('');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#666',
                  padding: '5px'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: '500',
                color: '#333'
              }}>
                {t('reports.checkType')}:
              </label>
              <select
                value={createPendingCheckData.check_type}
                onChange={(e) => setCreatePendingCheckData({
                  ...createPendingCheckData,
                  check_type: e.target.value
                })}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid rgba(102, 126, 234, 0.2)',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: 'rgba(255, 248, 241, 0.88)',
                  transition: 'all 0.3s ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = 'rgba(102, 126, 234, 0.5)';
                  e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(102, 126, 234, 0.2)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <option value="">{t('reports.selectCheckType')}</option>
                <option value="lab">{t('checkTypes.lab')}</option>
                <option value="quick">{t('checkTypes.quick')}</option>
                <option value="body">{t('checkTypes.body')}</option>
                <option value="scan">{t('checkTypes.scan')}</option>
                <option value="tissue">{t('checkTypes.tissue')}</option>
                <option value="scope">{t('checkTypes.scope')}</option>
                <option value="other">{t('checkTypes.other')}</option>
              </select>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: '500',
                color: '#333'
              }}>
                {t('reports.description')}:
              </label>
              <textarea
                value={createPendingCheckData.description}
                onChange={(e) => setCreatePendingCheckData({
                  ...createPendingCheckData,
                  description: e.target.value
                })}
                placeholder={t('reports.createPendingCheckDescriptionPlaceholder')}
                style={{
                  width: '100%',
                  minHeight: '100px',
                  padding: '12px',
                  border: '2px solid rgba(102, 126, 234, 0.2)',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: 'rgba(255, 248, 241, 0.88)',
                  color: '#1a202c',
                  transition: 'all 0.3s ease',
                  boxSizing: 'border-box',
                  resize: 'vertical'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = 'rgba(102, 126, 234, 0.5)';
                  e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(102, 126, 234, 0.2)';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '15px',
              marginTop: '30px'
            }}>
              <button
                onClick={() => {
                  setShowCreatePendingCheck(false);
                  setCreatePendingCheckData({ check_type: '', description: '' });
                  setError('');
                }}
                disabled={creatingPendingCheck}
                style={{
                  ...getButtonStyle('dark'),
                  padding: '10px 20px',
                  fontSize: '14px',
                  opacity: creatingPendingCheck ? 0.4 : 1,
                  cursor: creatingPendingCheck ? 'not-allowed' : 'pointer'
                }}
                onMouseEnter={(e) => !creatingPendingCheck && handleButtonHover(e, true)}
                onMouseLeave={(e) => !creatingPendingCheck && handleButtonHover(e, false)}
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={handleCreatePendingCheck}
                disabled={creatingPendingCheck || !createPendingCheckData.check_type || !createPendingCheckData.description}
                style={{
                  ...getButtonStyle('success'),
                  padding: '10px 20px',
                  fontSize: '14px',
                  opacity: (creatingPendingCheck || !createPendingCheckData.check_type || !createPendingCheckData.description) ? 0.4 : 1,
                  cursor: (creatingPendingCheck || !createPendingCheckData.check_type || !createPendingCheckData.description) ? 'not-allowed' : 'pointer'
                }}
                onMouseEnter={(e) => !(creatingPendingCheck || !createPendingCheckData.check_type || !createPendingCheckData.description) && handleButtonHover(e, true)}
                onMouseLeave={(e) => !(creatingPendingCheck || !createPendingCheckData.check_type || !createPendingCheckData.description) && handleButtonHover(e, false)}
              >
                {creatingPendingCheck ? t('reports.creating') : t('common.create')}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ReportReview; 
